{
 "alert.added": "New stop added — {name}",
 "alert.allMoved": {
  "one": "All {n} stop moved to another driver — you have nothing to deliver on this route",
  "other": "All {n} stops moved to another driver — you have nothing to deliver on this route"
 },
 "alert.kind.cancel": "Stop cancelled",
 "alert.kind.hold": "Account on hold",
 "alert.kind.money": "Payment",
 "alert.kind.new": "New stop",
 "alert.kind.reopt": "Route re-sequenced",
 "alert.kind.update": "Route update",
 "alert.manyAdded": "{n} stops added — {names} and {more} more",
 "alert.manyRemoved": "{n} stops removed — do NOT deliver to {names} and {more} more",
 "alert.removed": "Stop removed — do NOT deliver to {name}",
 "alert.reordered": "Route re-sequenced — check your next stop",
 "alert.showStops": "Show me my stops",
 "badge.timed": "TIMED",
 "badge.urgent": "URGENT",
 "badge.willCall": "WILL-CALL",
 "block.codCharge": "COD · charge the card on file to deliver",
 "block.codNoCard": "COD · no valid card on file — charge a card or get an office override",
 "block.collect": "Collect payment (or get an office override) to deliver",
 "block.hold": "On HOLD — do not deliver. Call your route manager",
 "block.pallets": "Sculpture · scan all {n} pallets ({done}/{n} done) — a missing part breaks the order",
 "brief.day": "Day",
 "brief.night": "Night",
 "brief.outOf": "Out of",
 "brief.shift": "Shift",
 "brief.stops": "Stops",
 "brief.truck": "Truck",
 "check.brakes": "Brakes",
 "check.checkAll": "Check all {n} items",
 "check.clean": "Cab & cargo clean",
 "check.continue": "Continue to load",
 "check.fuel": "Fuel level",
 "check.lights": "Lights & signals",
 "check.locked": "Truck check is locked — the route is in progress",
 "check.oil": "Oil & coolant",
 "check.passed": "Inspection passed — Load",
 "check.photoNotKept": "Photo taken, but this phone is out of space for it — it will be lost if the app closes",
 "check.photoOnFile": "Photo on file",
 "check.photoThis": "Photograph this item",
 "check.photographed": "{item} photographed",
 "check.progress": "{done} of {n} checked — tap each item to check it (taking its photo checks it too)",
 "check.psi": "{tire} PSI",
 "check.reefer": "Reefer / freezer temp",
 "check.safety": "Safety kit & straps",
 "check.tire.FL": "FL",
 "check.tire.FR": "FR",
 "check.tire.RL": "RL",
 "check.tire.RR": "RR",
 "check.title": "Truck inspection · {truck}",
 "common.backWord": "Back",
 "common.cancel": "Cancel",
 "common.close": "Close",
 "common.decrease": "decrease",
 "common.done": "Done",
 "common.driver": "Driver",
 "common.increase": "increase",
 "common.optional": "optional",
 "common.signOut": "Sign out",
 "common.tryAgain": "try again",
 "common.unknown": "unknown",
 "contact.calling": "Calling {name} · {phone}",
 "contact.noPhone": "No phone on file for {name}",
 "contact.textReady": "\"~{n} min out\" text ready for {name}",
 "del.amountDue": "Amount due",
 "del.deliveredNow": "Delivered now",
 "del.deposit": "Deposit",
 "del.empties": "Empties returned",
 "dep.title": "Containers (deposits)",
 "dep.back": "Back (empties)",
 "dep.out": "{n} out",
 "dep.held": "customer has {n}",
 "dep.noCharge": "No charge — no deposit price set",
 "dep.each": "{money} deposit each",
 "dep.left": "{n} left with the customer: deposit {money} on the invoice",
 "dep.leftNc": "{n} left with the customer — no charge, counted",
 "dep.extra": "{n} extra back: credit {money}",
 "dep.extraNc": "{n} extra back — no charge, counted",
 "dep.even": "Even exchange — no deposit charge",
 "dep.more": "Picked up other containers",
 "dh.inv.empties": "Empties on the truck",
 "del.lease": "Also collect lease due {money}",
 "del.palletScanned": "Pallet {n}/{of} scanned",
 "del.resolveFirst": "Resolve the blocker first",
 "del.savedOffline": "Saved — will send when back online",
 "detail.collected": "Collected",
 "detail.customer": "Customer",
 "detail.did": "Did",
 "detail.readOnly": "Read-only record.",
 "detail.readOnlySkipped": "Read-only record — service it now if you can return.",
 "detail.reason": "Reason",
 "detail.timeOnStop": "Time on stop",
 "dh.arrive.away": "You are {dist} — this is the stop ahead",
 "dh.arrive.gps": "GPS has you at the stop",
 "dh.arrive.here": "I'm here",
 "dh.arrive.none": "{why} — your arrival is recorded when you start",
 "dh.cap.aria": "Sync: {state}, last confirmed {time}. Open sync details.",
 "dh.cap.checking": "Checking",
 "dh.cap.demo": "Demo",
 "dh.cap.demoAria": "Demo build — there is no office server to sync with. Open sync details.",
 "dh.cap.demoSub": "no server",
 "dh.cap.lastFailed": "Send failed",
 "dh.cap.live": "Live",
 "dh.cap.notLive": "Not live",
 "dh.cap.offline": "Offline",
 "dh.cap.offlineAria": {
  "one": "Offline — {n} item saved on this phone. Open sync details.",
  "other": "Offline — {n} items saved on this phone. Open sync details."
 },
 "dh.cap.refused": {
  "one": "{n} refused",
  "other": "{n} refused"
 },
 "dh.cap.retrying": {
  "one": "{n} retrying",
  "other": "{n} retrying"
 },
 "dh.cap.saved": {
  "one": "{n} saved",
  "other": "{n} saved"
 },
 "dh.cap.sending": "Sending…",
 "dh.cap.waiting": {
  "one": "{n} waiting",
  "other": "{n} waiting"
 },
 "dh.card.eta": "ETA {time}",
 "dh.card.last": "Last {day} · {what}",
 "dh.card.lastUnits": "{n} {unit}",
 "dh.card.usual": "Usual order",
 "dh.check.items": "Walk-around · {done} of {n}",
 "dh.check.passed": "Inspection passed — load the truck",
 "dh.check.tires": "Tire pressure",
 "dh.check.title": "Pre-trip · {truck}",
 "dh.check.toToday": "Back to Today",
 "dh.chip.hold": "HOLD",
 "dh.chip.holdAmt": "HOLD {money}",
 "dh.chip.pastDue": "PAST DUE",
 "dh.chip.pastDueAmt": "PAST DUE {money}",
 "dh.done.collected": "Collected {money} · {method}",
 "dh.done.credit": "{money} kept as credit on the account",
 "dh.done.creditUsed": "Account credit {money} applied",
 "dh.done.email": "Email invoice",
 "dh.done.text": "Text invoice",
 "dh.done.textOk": "Customer said OK — text it",
 "dh.done.texted": "Texted to {to}",
 "dh.done.textQueued": "Will text when back online",
 "dh.done.emailed": "Sent",
 "dh.done.list": "Stop list",
 "dh.done.local": "Saved on this phone (demo — no office)",
 "dh.done.next": "Next stop · {name}",
 "dh.done.notHere": "needs the office",
 "dh.done.print": "Print",
 "dh.done.queued": "Saved on this phone — it will be sent",
 "dh.done.receipt": "Receipt",
 "dh.done.refused": "Not recorded by the office — see Sync",
 "dh.done.sending": "Sending to the office…",
 "dh.done.sent": "The office has it",
 "dh.done.title": "Stop complete",
 "dh.eod.confirm": "Confirm unload",
 "dh.eod.diff": "Diff",
 "dh.eod.journal": "Cash journal",
 "dh.eod.open": {
  "one": "{n} stop is still open",
  "other": "{n} stops are still open"
 },
 "dh.eod.print": "Print",
 "dh.eod.sub": "{done} done · {skipped} skipped · of {of}",
 "dh.eod.unload": "Count in what came back",
 "dh.equip.none": "No equipment recorded at this stop on this phone. Asset-tag scanning comes later.",
 "dh.hist.delivered": "{n} delivered",
 "dh.hist.notHere": "History comes from the office — not on this phone.",
 "dh.hist.served": "Served",
 "dh.hist.skipped": "Skipped",
 "dh.hist.started": "Started, not completed",
 "dh.info.address": "Address",
 "dh.info.email": "Email",
 "dh.info.order": "Order",
 "dh.info.phone": "Phone",
 "dh.info.terms": "Terms",
 "dh.inv.row": "{n} of {of} loaded",
 "dh.load.accept": "Accept item {n}",
 "dh.load.count": {
  "one": "Load list · {n} item",
  "other": "Load list · {n} items"
 },
 "dh.load.explain": "Load first in, last out — the app walks you item by item. Accept each; a dry-ice bin shows what is inside.",
 "dh.load.qrAll": "Truck QR",
 "dh.load.serverLocked": "The office already has this route started — {n} item(s) were not changed and are shown as the office has them.",
 "dh.load.start": "Start loading",
 "dh.load.submit": "Load confirmed — start route",
 "dh.load.tag": "Tag pending — scan the asset tag",
 "dh.load.title": "Load",
 "dh.look.autoAt": "Day from {rise} · night from {set}",
 "dh.look.autoClock": "Day 7 AM – 7 PM until the phone knows where it is",
 "dh.look.company": "Use company look",
 "dh.look.day": "Day",
 "dh.look.hint.flight": "Timeline",
 "dh.look.hint.grid": "Big tiles",
 "dh.look.hint.ledger": "Default",
 "dh.look.hint.nextstop": "One card",
 "dh.look.mode.auto": "Auto",
 "dh.look.mode.day": "Always day",
 "dh.look.mode.night": "Always night",
 "dh.look.night": "Night",
 "dh.look.openStop": "Open stop",
 "dh.look.pinned": "Stays this way until you change it",
 "dh.look.preview": "Preview",
 "dh.look.sampleStop": "Your next stop",
 "dh.look.start": "Start with this look",
 "dh.look.sub": "Change it any time in More",
 "dh.look.title": "Pick your look",
 "dh.more.equip": "Equipment scan",
 "dh.more.equipNotYet": "Equipment scan — not available yet",
 "dh.more.faceIsOn": "Face ID sign-in is on — turn off",
 "dh.more.faceOn": "Sign in with Face ID on this phone",
 "dh.more.inventory": "Truck inventory",
 "dh.more.look": "Look",
 "dh.more.pickLook": "Layout and colours · {layout}",
 "dh.more.qr": "Truck QR",
 "dh.more.recap": "Previous day’s recap",
 "dh.more.signedInTo": "Signed in to {tenant}",
 "dh.more.sync": "Sync status · Sync now",
 "dh.more.themeNow": "Showing {theme} now",
 "dh.more.themeWaiting": "The new colours apply when this screen is idle",
 "dh.more.today": "Your day",
 "dh.more.todayRow": "Today · gates and end of day",
 "dh.more.transfer": "Transfer to another truck",
 "dh.more.truck": "Truck",
 "dh.notes.none": "No notes for this place yet.",
 "dh.offline.banner": {
  "one": "Offline since {time} — {n} item saved on this phone",
  "other": "Offline since {time} — {n} items saved on this phone"
 },
 "dh.or.credit": "Credit {amount}",
 "dh.pay.checkAmount": "Check amount",
 "dh.pay.checkNo": "Check number",
 "dh.pay.coveredByCredit": "Finish — paid by account credit",
 "dh.pay.creditRest": "{money} stays on the account",
 "dh.pay.creditUsed": "Account credit {money} taken off",
 "dh.pay.del": "Delete",
 "dh.pay.due": "Due",
 "dh.pay.exact": "Exact",
 "dh.pay.m.card": "Card",
 "dh.pay.m.cash": "Cash",
 "dh.pay.m.check": "Check",
 "dh.pay.needRef": "Enter the check number",
 "dh.pay.noCard": "No valid card on file",
 "dh.pay.override": "Finish with the office code",
 "dh.pay.ovp.change": "Give {money} change",
 "dh.pay.ovp.credit": "Keep {money} as credit on {name}'s account",
 "dh.pay.ovp.sub": "What happened to the extra {money}?",
 "dh.pay.ovp.subCheck": "A check is never cashed out — the extra {money} can only stay as credit.",
 "dh.pay.ovp.title": "{received} taken · {due} due",
 "dh.pay.received": "Received",
 "dh.pay.record": "Record {method} {money}",
 "dh.pay.recordPay": "Record {method} {money}",
 "dh.pay.title": "Collect {money}",
 "dh.pay.titlePay": "Take payment · {money} owed",
 "dh.recap.onAccount": "{money} kept on account",
 "dh.record.arrival": "Arrival",
 "dh.record.back": "Back to the stop list",
 "dh.record.byGps": "Confirmed by GPS",
 "dh.record.byTap": "Recorded by the driver",
 "dh.record.delivered": "Delivered",
 "dh.record.done": "Completed",
 "dh.record.reservice": "Service this stop now",
 "dh.record.skipped": "Skipped",
 "dh.screen.endOfDay": "End of day",
 "dh.screen.load": "Load",
 "dh.screen.pretrip": "Pre-trip",
 "dh.shiftNotSaved": "This phone is out of storage space — today’s progress may be lost if the app closes. Free some space on the phone.",
 "dh.skip.title": "Skip {name}",
 "dh.cf.back": "Go back",
 "dh.cf.yes": "Confirm",
 "dh.cf.skip.aria": "Skip — {reason}",
 "dh.cf.close.aria": "Close — {reason}",
 "dh.cf.short.title": "Deliver {n} of {of}?",
 "dh.cf.short.body": {
  "one": "The other 1 goes back to the office as unscheduled.",
  "other": "The other {n} go back to the office as unscheduled."
 },
 "dh.cf.short.yes": "Deliver {n}",
 "dh.cf.short.noneTitle": "Deliver nothing?",
 "dh.cf.short.noneBody": {
  "one": "It goes back to the office as unscheduled.",
  "other": "All {n} go back to the office as unscheduled."
 },
 "dh.cf.short.noneYes": "Deliver nothing",
 "dh.cf.skip.sheet": "It goes back to the office as skipped and carries to the next day. Tap the reason to skip it.",
 "dh.cf.close.skipN": {
  "one": "{n} stop goes back to the office as skipped and carries to the next day.",
  "other": "{n} stops go back to the office as skipped and carry to the next day."
 },
 "dh.cf.close.pick": "Tap the reason to close them.",
 "dh.cf.skip.title": "Skip {name}?",
 "dh.cf.close.title": {
  "one": "Close {n} open stop?",
  "other": "Close {n} open stops?"
 },
 "dh.cf.close.cancel": {
  "one": "{n} off-route stop is cancelled — it leaves your day.",
  "other": "{n} off-route stops are cancelled — they leave your day."
 },
 "dh.cf.done.title": "End your day on {route}?",
 "dh.cf.done.count": "The office gets your end-of-day count: {back} came back, {damaged} damaged.",
 "dh.cf.done.body": "Your day is closed on this phone and the office sees you as done.",
 "dh.cf.done.yes": "End my day",
 "dh.cf.offEnd.title": "End off route?",
 "dh.cf.offEnd.body": {
  "one": "{reason} — {mins} min, {n} log entry. The office sees it as ended; going off route again starts a new one.",
  "other": "{reason} — {mins} min, {n} log entries. The office sees it as ended; going off route again starts a new one."
 },
 "dh.cf.fill0.title": "Finish {name} with nothing handed over?",
 "dh.cf.fill0.body": "No products are on this stop. The office sees it as served with nothing delivered.",
 "dh.cf.fill0.yes": "Finish with nothing",
 "dh.cf.flag.title": "Send your count for truck {truck}?",
 "dh.cf.flag.diff": {
  "one": "{n} item differs from what the warehouse staged: {list}.",
  "other": "{n} items differ from what the warehouse staged: {list}."
 },
 "dh.cf.flag.same": "Your count matches what the warehouse staged.",
 "dh.cf.flag.body": "Your count becomes this truck’s load, and the office is told.",
 "dh.cf.count.title": "Send your count for {route}?",
 "dh.cf.count.body": {
  "one": "{units} in all across {n} product — this becomes what is on your truck, and selling unlocks.",
  "other": "{units} in all across {n} products — this becomes what is on your truck, and selling unlocks."
 },
 "dh.cf.count.zero": {
  "one": "{n} product is counted as 0.",
  "other": "{n} products are counted as 0."
 },
 "dh.cf.xfer.title": "Move {qty} × {item} to truck {truck}?",
 "dh.cf.xfer.body": "It comes off your truck’s count and goes on truck {truck}’s. Only a transfer back undoes it.",
 "dh.cf.signout.title": "Sign out of this phone?",
 "dh.cf.signout.unsent": {
  "one": "{n} change has not reached the office yet. It stays on this phone and is sent the next time you sign in here (within a day) — never under anyone else.",
  "other": "{n} changes have not reached the office yet. They stay on this phone and are sent the next time you sign in here (within a day) — never under anyone else."
 },
 "dh.cf.signout.body": "Your route leaves this screen until you sign in again.",
 "dh.cf.face.title": "Turn off Face ID / fingerprint sign-in?",
 "dh.cf.face.body": "This phone no longer offers it at sign-in until you turn it on again here.",
 "dh.cf.face.yes": "Turn it off",
 "dh.stop.add": "Add",
 "dh.stop.cantSign": "Customer can't sign",
 "dh.stop.collect": "Collect {money}",
 "dh.stop.credit": "{money} credit on this account — taken off this invoice",
 "dh.stop.finish": "Finish stop",
 "dh.stop.hold": "The office put this customer on hold — do not deliver. Call your route manager for next steps. You can still take a payment",
 "dh.stop.lease": "Lease due",
 "dh.stop.misc": "Add from this truck",
 "dh.stop.noPayment": "No payment",
 "dh.stop.noPrice": "No price — the office prices it",
 "dh.fill.priceNeeded": "Price needed",
 "dh.fill.needsPrice": "{n} without a price",
 "dh.fill.officePrices": "the office prices them",
 "dh.stop.notNext": "Not your next stop — working it moves it up",
 "dh.stop.officeChanged": "Office changed this order · {time}",
 "dh.stop.officeNote": "Office note: {notes}",
 "dh.stop.ofOrdered": "of {n} {unit} ordered",
 "dh.stop.pastDue": "Past due {money} on this account — ask for it",
 "dh.stop.payOnly": "Take payment only",
 "dh.stop.photo": "Delivery photo",
 "dh.stop.photosN": {
  "one": "{n} photo",
  "other": "{n} photos"
 },
 "dh.stop.redo": "Redo",
 "dh.stop.required": "Required",
 "dh.stop.scanPallet": "Scan pallet {n}",
 "dh.stop.sign": "Signature",
 "dh.stop.signFirst": "Get the signature first (or say why there isn't one)",
 "dh.stop.signNow": "Sign",
 "dh.stop.signedBy": "Signed · {name}",
 "dh.stop.takeIfOffered": "Take payment",
 "dh.stop.takePhoto": "Photo",
 "dh.stop.thisStop": "This stop",
 "dh.stop.total": "Total",
 "dh.routing.nowLocked": "The office now sets your stop order — reordering is off.",
 "dh.routing.nowAuto": "You can reorder your stops; a new order from the office replaces yours straight away.",
 "dh.routing.nowChoose": "You can reorder your stops; a new order from the office will ask you: use it or keep yours.",
 "dh.routing.officeOrder": "Office order",
 "dh.routing.officeOrderSub": "Your company sets the stop order",
 "dh.routing.yourOrder": "Your stop order",
 "dh.routing.subAuto": "A new order from the office applies straight away",
 "dh.routing.subChoose": "A new order from the office asks you first",
 "dh.routing.reorder": "Reorder",
 "dh.routing.optimize": "Optimize from here",
 "dh.routing.needsConnection": "Needs a connection",
 "dh.routing.needsTwo": "Needs two stops still to do",
 "dh.routing.lockedNoMove": "Your company sets the stop order — this stop keeps its place.",
 "dh.routing.reoTitle": "Reorder your stops",
 "dh.routing.reoSub": "Move the stops still to do. Stops already served keep their places.",
 "dh.routing.served": "{n} served — they keep their places",
 "dh.routing.up": "Move {name} up",
 "dh.routing.down": "Move {name} down",
 "dh.routing.moved": "moved",
 "dh.routing.save": "Save order",
 "dh.routing.undo": "Undo",
 "dh.routing.saved": "Stop order saved — the office sees it.",
 "dh.routing.savedQueued": "Stop order saved on this phone — it goes to the office when you have signal.",
 "dh.routing.optLoading": "Working out a better order from here…",
 "dh.routing.savesMi": "saves ~{n} mi",
 "dh.routing.savesMin": "~{n} min less",
 "dh.routing.straight": "(≈ straight-line)",
 "dh.routing.optNoChange": "Your order is already the best one from here.",
 "dh.routing.optNoSaving": "No saving was worked out for this order.",
 "dh.routing.optFailed": "Could not work out an order — try again.",
 "dh.routing.apply": "Use this order",
 "dh.routing.pendingBanner": "The office sent a new stop order · from {who}",
 "dh.routing.pendingTitle": "New stop order from the office",
 "dh.routing.from": "From {who}",
 "dh.routing.useNew": "Use new order",
 "dh.routing.keepMine": "Keep my order",
 "dh.routing.newOrder": "New order",
 "dh.routing.yourNow": "Your order now",
 "dh.routing.usedNew": "Using the new order.",
 "dh.routing.keptMine": "Keeping your order — the office is told.",
 "dh.routing.decQueued": "Your answer is saved on this phone — it goes to the office when you have signal.",
 "dh.routing.remind": "The office's new stop order is still waiting for your answer.",
 "dh.routing.officeUpdated": "Route order updated by the office",
 "dh.routing.review": "Review",
 "dh.routing.src.monitor": "Monitor agent",
 "dh.routing.src.nightly": "the nightly plan",
 "dh.routing.src.optimizer": "the route optimizer",
 "dh.routing.src.office": "the office",
 "dh.stops.allDone": "Every stop is closed — {done} done, {skipped} skipped, {money} collected. End of day is next.",
 "dh.stops.call": "Call",
 "dh.stops.done": "Done",
 "dh.stops.doneSkipped": "{done} done · {skipped} skipped",
 "dh.stops.history": "History",
 "dh.stops.navigate": "Navigate",
 "dh.stops.navigateTo": "Navigate to stop",
 "dh.stops.next": "Next",
 "dh.stops.noneDone": "No stops done yet.",
 "dh.stops.noneSkipped": "No stops skipped.",
 "dh.stops.open": "Open {name}",
 "dh.stops.remaining": "Remaining",
 "dh.stops.routeUpdated": "Route re-sequenced — tap when stopped to see the new order",
 "dh.stops.skip": "Skip",
 "dh.stops.skipped": "Skipped",
 "dh.stops.stopNofM": "Stop {n} of {of}",
 "dh.stops.textEta": "Text ETA",
 "dh.stops.thenN": {
  "one": "Then · {n} more",
  "other": "Then · {n} more"
 },
 "dh.sync.attentionN": "Needs attention · {n}",
 "dh.sync.backingOff": "Will try again",
 "dh.sync.count": "No.",
 "dh.sync.lastOffline": "Last offline {from} – {to}",
 "dh.sync.moneyKept": "Kept on this phone. Money items can't be deleted here.",
 "dh.sync.oldest": "Oldest",
 "dh.sync.refused": "Refused",
 "dh.sync.title": "Sync",
 "dh.sync.toldAt": "The office has been told · {time}",
 "dh.tab.deliver": "Deliver",
 "dh.tab.equip": "Equip.",
 "dh.tab.history": "History",
 "dh.tab.info": "Info",
 "dh.tab.notes": "Notes",
 "dh.today.afterLast": "After the last stop",
 "dh.today.ahead": "Preview · {day}",
 "dh.today.aheadNote": "Read only — nothing can be done on a day ahead.",
 "dh.today.dateLine": "{day} · {name}",
 "dh.today.done": "Done",
 "dh.today.endOfDay": "End of day",
 "dh.today.first": "First",
 "dh.today.gates": "Before you roll",
 "dh.today.load": "Load the truck",
 "dh.today.loadLabel": "Load",
 "dh.today.loadTruck": "Load the truck",
 "dh.today.locked": "Done · locked",
 "dh.today.notYet": "Not done yet",
 "dh.today.orders": {
  "one": "{n} order",
  "other": "{n} orders"
 },
 "dh.today.pretrip": "Pre-trip inspection",
 "dh.today.progress": "{done} done · {skipped} skipped · of {of}",
 "dh.today.ready": "Ready",
 "dh.today.routeStops": {
  "one": "{n} route stop",
  "other": "{n} route stops"
 },
 "dh.today.seeEndOfDay": "See end of day",
 "dh.today.startPretrip": "Start pre-trip",
 "dh.today.startRoute": "Start route",
 "dh.today.stopList": {
  "one": "Stop list · {n} stop",
  "other": "Stop list · {n} stops"
 },
 "dh.today.toStops": "Back to my stops",
 "dh.today.units": "{n} {unit}",
 "dh.today.watchN": "Watch list · {n}",
 "dh.today.watchNone": "No holds or past-due accounts on today's route.",
 "dh.today.willCall": {
  "one": "{n} will-call",
  "other": "{n} will-call"
 },
 "dh.view.list": "List",
 "dh.view.map": "Map",
 "dh.xfer.confirm": "Confirm transfer",
 "dh.xfer.record": "Record transfer",
 "dh.xfer.title": "Transfer to another truck",
 "display.company": "Company ({value})",
 "display.dayTheme": "Day colours",
 "display.layout": "Layout",
 "display.layout.flight": "Flight deck",
 "display.layout.grid": "Glove Grid",
 "display.layout.ledger": "Ledger",
 "display.layout.nextstop": "Next stop first",
 "display.mode.auto": "Auto by sun",
 "display.mode.day": "Day",
 "display.mode.night": "Night",
 "display.nightTheme": "Night colours",
 "display.theme.flight-dark": "Flight deck dark",
 "display.theme.flight-light": "Flight deck light",
 "display.theme.iris-dark": "Iris dark",
 "display.theme.iris-light": "Iris light",
 "display.theme.ledger-dark": "Ledger dark",
 "display.theme.ledger-light": "Ledger light",
 "display.theme.navy-dark": "Navy dark",
 "display.theme.navy-light": "Navy light",
 "display.theme.slate-dark": "Slate dark",
 "display.theme.slate-light": "Slate light",
 "display.themeMode": "Theme",
 "eod.card": "Card charged",
 "eod.cash": "Cash / check / MO",
 "eod.credits": "Credits applied",
 "eod.delivered": "Delivered",
 "eod.left": "Left",
 "eod.noteDelivered": "Delivered:",
 "eod.noteOut": "Out:",
 "eod.noteOutCounted": "the load you counted at the dock.",
 "eod.noteOutNone": "no load was counted, so none is shown.",
 "eod.noteReturned": "Returned and left: not recorded yet — count them in at the dock. Nothing here is estimated.",
 "eod.noteServed": "your served stops and their order lines.",
 "eod.noteUnattributed": {
  "one": "{n} served stop has no product lines, so it is not shown per product.",
  "other": "{n} served stops have no product lines, so they are not shown per product."
 },
 "eod.nothing": "Nothing recorded on this truck today.",
 "eod.out": "Out",
 "eod.product": "Product",
 "eod.ret": "Ret",
 "eod.returned": "Returned",
 "eod.sold": "Sold",
 "eod.total": "Total collected",
 "eod.varDemoTitle": "Variance · product out / returned / sold",
 "eod.varLiveTitle": "Variance · product out / delivered / returned",
 "equip.notYet": "Equipment scanning is not available yet — nothing would reach the office",
 "eta.early": "early",
 "eta.late": "late",
 "eta.ontime": "on time",
 "flow.alreadyCollected": "Already collected",
 "flow.callOffice": "call office",
 "flow.checkingLocation": "Checking your location…",
 "flow.customer": "customer",
 "flow.did.exchange": "Exchanged equipment",
 "flow.did.install": "Installed equipment",
 "flow.did.return": "Returned equipment",
 "flow.did.service": "Serviced equipment",
 "flow.didDeliver": "Delivered {n}/{of} {unit} · {money}",
 "flow.eqNotScannedShort": "not scanned",
 "flow.eqSub": "Asset-tag scanning is not available on the handheld yet. Do the work, then continue — the stop is recorded as not scanned.",
 "flow.namePh": "name",
 "flow.noFix": "No GPS fix",
 "flow.noSignature": "No signature · {why}",
 "flow.notTimed": "Nothing is timed until you get there. Tap below if you are already on site.",
 "flow.overrideIfShort": "Office override (if short)",
 "flow.printed": "printed",
 "flow.reason.deliver": "Deliver order",
 "flow.reason.exchange": "Equipment exchange",
 "flow.reason.install": "Install equipment",
 "flow.reason.return": "Return equipment",
 "flow.reason.service": "Service equipment",
 "flow.receivedBy": "Received by",
 "flow.releaseCode": "Office release code",
 "flow.scannedOf": "{done}/{n} scanned",
 "flow.shortNote": "Short amount — remainder auto-routed to Unscheduled.",
 "gps.mAway": "{n} m away",
 "gps.miAway": "{n} mi away",
 "gps.why.blocked": "location is blocked",
 "gps.why.looking": "still looking",
 "gps.why.noLocation": "this device has no location",
 "gps.why.noSignal": "no signal",
 "gps.why.rough": "the fix is too rough to tell",
 "hist.accessNotes": "access notes",
 "hist.back": "Back to the stop",
 "hist.banner": "This site has history",
 "hist.bannerSub": "{bits} — tap to read",
 "hist.deliveredOf": "{n} delivered of {of} ordered",
 "hist.footer": "Recorded by whoever served this site before — it stays with the site, not with the route.",
 "hist.gettingIn": "Getting in",
 "hist.loadFailed": "Could not load this site’s history",
 "hist.loading": "Loading this site’s history…",
 "hist.noDriver": "driver not recorded",
 "hist.none": "No previous visits recorded.",
 "hist.photos": {
  "one": "{n} photo on file for that visit · viewable in the office",
  "other": "{n} photos on file for that visit · viewable in the office"
 },
 "hist.picked": "{n} picked up",
 "hist.prevVisits": {
  "one": "{n} previous visit",
  "other": "{n} previous visits"
 },
 "hist.served": "Served",
 "hist.thisSite": "This site",
 "hist.title": "{site} — history",
 "hist.you": "(you)",
 "home.moreTitle": "Theme, language, sign-in",
 "home.nextDay": "Next day",
 "home.noRoutes": "No routes to drive",
 "home.noRoutesHint": "A driver’s run appears here once routes are built (Routes) and dispatched (Board).",
 "home.prevDay": "Previous day",
 "home.switchRoute": "Switch route",
 "imp.banner": "IMPERSONATING {name}",
 "imp.by": "by {name}",
 "imp.exit": "Exit",
 "inv.explain": "Available now (loaded minus delivered so far).",
 "inv.none": "No load on this truck.",
 "item.added": "Added {qty}× {item} at customer request",
 "lc.addLabel": "Add a product not on the plan",
 "lc.addOption": "Add a product not on the plan…",
 "lc.emptyBack": "Go back",
 "lc.emptyBody": "Nothing is recorded as aboard {route} — every line is 0. Confirm only if the truck really is leaving empty.",
 "lc.emptyGo": "Confirm empty load",
 "lc.emptyTitle": "Confirm an empty load?",
 "lc.extra": "extra · not on the plan",
 "lc.extraN": "+{n} extra",
 "lc.less": "One less {item}",
 "lc.line": "{loaded} loaded · plan {plan}",
 "lc.loaded": "{item} loaded",
 "lc.more": "One more {item}",
 "lc.plan": "plan {n}",
 "lc.shortN": "{n} short",
 "lc.sub": "start from the plan; change it to what you actually loaded",
 "lc.title": "Count what is on the truck",
 "load.allConfirmed": {
  "one": "{n} item scanned & confirmed in order.",
  "other": "All {n} items scanned & confirmed in order."
 },
 "load.alreadyBound": "Already bound · {tag}",
 "load.binSub": {
  "one": "{n} delivery inside · dry-ice bin (tag at load)",
  "other": "{n} deliveries inside · dry-ice bin (tag at load)"
 },
 "load.equipment": "equipment",
 "load.filoNext": "Load in FILO order — item {n} is next",
 "load.freezerSub": "{reason} · asset (tag at load)",
 "load.itemLoaded": "{item} loaded",
 "load.loadNext": "Load this next (FILO order) — scan to accept.",
 "load.locked": "Load is locked — the route is in progress",
 "load.nothing": "Nothing to load on this route.",
 "load.palletSub": "{qty} {unit} · product pallet",
 "load.progress": "{done}/{of} loaded",
 "load.qrNote": "Loader pre-loaded? One QR scan verifies the whole truck (loader accountable).",
 "load.startRoute": "Start route",
 "login.callOffice": "Call the office",
 "login.driverId": "Driver ID",
 "login.emailOrId": "Email or driver ID",
 "login.emailOrIdPh": "you@company.com",
 "login.enterBoth": "Enter your driver ID and password.",
 "login.enterEmailOrId": "Enter your email (or driver ID) and password.",
 "login.faceEnableFailed": "Could not enable Face ID on this phone. Reason: {why} — your password still works. Tap to close.",
 "login.faceEnabled": "Face ID sign-in enabled on this phone",
 "login.faceFailed": "Face ID did not work. Use your password.",
 "login.faceUnlock": "Unlock with Face ID / fingerprint",
 "login.faceWaiting": "Waiting for Face ID…",
 "login.help": "Your dispatcher issues these. If you have lost them, call the office — they can reset it while you wait.",
 "login.helpCall": "Your dispatcher issues these. Can't log in? {link} — they can reset it while you wait.",
 "login.noReach": "Could not reach the office. Check your signal and try again.",
 "login.password": "Password",
 "login.signIn": "Sign in",
 "login.signingIn": "Signing in…",
 "login.a2hs.title": "On iPhone or iPad: add this app to your Home Screen first, then sign in from its icon.",
 "login.a2hs.s1": "Tap ⋯ at the bottom of Safari (or the Share button), then Share.",
 "login.a2hs.s2": "Tap Add to Home Screen, then Add.",
 "login.a2hs.s3": "Open the new Driver icon and sign in there. It stays signed in.",
 "login.title": "Driver sign-in",
 "login.userPh": "e.g. marco.ruiz",
 "login.wrong": "Incorrect username or password.",
 "money.cardNotRecorded": "The {money} card payment at {name} was NOT recorded — a card is taken only on the payment link or QR code. Send the customer the link, or sort it out with the office.",
 "money.creditTookPart": "{name}'s account credit of {credit} paid part of this invoice — {money} you took is not recorded. Give it back, or call the office to keep it as credit.",
 "money.notRecorded": "{money} was NOT recorded at {name} — {why}. Hand it back to the customer, or sort it out with the office.",
 "money.stillOwed": "{name} still owes {money} on this invoice — the account credit was already used. Collect it, or leave it on the account.",
 "money.whyAlreadyPaid": "this stop was already paid",
 "money.whyAlreadyPaidAmt": "this stop was already paid ({paid})",
 "money.whyOverBalance": "that is more than this delivery came to",
 "money.whyOverBalancePaid": "that is more than this delivery came to ({paid} was already paid)",
 "money.whyUnpricedCap": "this order has no price and that is over the limit that can be held for it",
 "more.faceOff": "Face ID sign-in turned off on this phone",
 "more.language": "Language",
 "more.title": "Handheld settings",
 "noroute.checkAgain": "Check again",
 "noroute.explain": "Nothing has been assigned to you yet. Tap Check again once dispatch has planned the day — or go Off Route if you are working anyway.",
 "noroute.offRoute": "Off Route",
 "noroute.recap": "Recap",
 "noroute.signOutTitle": "Sign out of the driver app",
 "noroute.spotCheck": "Spot Check",
 "noroute.title": "No route today",
 "notice.added": {
  "one": "{n} new stop added · {names}",
  "other": "{n} new stops added · {names}"
 },
 "notice.by": "by {by}",
 "notice.byAt": "by {by} at {time}",
 "notice.cancelled": "Cancelled",
 "notice.skipped": "Skipped",
 "notice.theOffice": "the office",
 "offroute.badge": "OFF ROUTE",
 "offroute.end": "End off route",
 "offroute.explain": "Tell the office what you are doing. It shows up in their feed with the time, so the day is on the record.",
 "offroute.logAdd": "Add to the log",
 "offroute.logBtn": "Log what you did",
 "offroute.logExplain": "Each line is stamped with the time it was entered.",
 "offroute.logPh": "e.g. Dropped 40 bags at Bay Shore Marina for RT-4",
 "offroute.logTitle": "Log what you did",
 "offroute.notePh": "Anything worth saying (optional)",
 "offroute.nothingYet": "Nothing logged yet.",
 "offroute.queued": "queued — will send when back online",
 "offroute.reason.cover": "Covering another route",
 "offroute.reason.equipment": "Equipment run",
 "offroute.reason.other": "Other",
 "offroute.reason.shop": "Shop / maintenance",
 "offroute.reason.training": "Training",
 "offroute.reason.warehouse": "Warehouse work",
 "offroute.reason.willcall": "Will-call delivery",
 "offroute.since": "Since {time} · {elapsed}",
 "offroute.start": "Start off route",
 "offroute.tapAgain": "Tap again to end",
 "offroute.title": "Go off route",
 "past.cancellations": "Cancellations",
 "past.delivered": "Delivered",
 "past.none": "No history for this day.",
 "past.ontime": "On-time",
 "past.outcome": "Outcome",
 "past.rolled": "Rolled over",
 "past.title": "{day} · shift history",
 "pay.cardNotYet": "Card payments are not available on the handheld yet — take cash or check, or the office can charge the card on file.",
 "pay.cardPrototype": "Demo only — no money moves. Card payments come with the QR / pay link.",
 "pay.charge": "Charge {money} to •{last4}",
 "pay.charged": "Charged {money}",
 "pay.chargedPrototype": "Card “charged” — demo only, no money moved",
 "pay.collectedDemo": "Payment {money} collected (demo — no office record)",
 "pay.enterAmount": "Enter the amount you took",
 "pay.m.card": "Card",
 "pay.m.cardonfile": "Card on file",
 "pay.m.cash": "Cash",
 "pay.m.check": "Check",
 "pay.m.moneyorder": "Money Order",
 "pay.moreThanLeft": "That is more than the {money} left on this stop",
 "pay.recordedInvoice": "{money} {method} recorded against the invoice",
 "pay.recordedLater": "{money} {method} recorded — goes on the invoice when you deliver",
 "pay.savedHere": "{money} saved on this phone — the office will see it when it can",
 "pay.saving": "Saving {money} {method}…",
 "pay.termsUnknownShort": "Terms not on this phone",
 "pay.title": "Take payment",
 "pay.toCredit": "+{money} — account credit",
 "photo.notSaved": "Photo not saved — {why}",
 "photo.onPhone": "Photo taken — kept on this phone (demo, no office)",
 "photo.saved": "Photo saved",
 "photo.savedOffline": "Photo saved — will send when back online",
 "photo.unreadable": "Could not read that photo. Take it again — if it keeps happening, choose a smaller photo, or on an iPhone set Settings > Camera > Formats to Most Compatible",
 "print.allowPopups": "Allow pop-ups to print the receipt",
 "print.opened": "Print dialog opened — the receipt prints in English",
 "qr.aim": "Aim at the truck's QR sticker",
 "qr.assets": "Assets",
 "qr.assetsVal": "{n} (freezers / dry-ice bins)",
 "qr.explain": "One scan pulls up today's manifest for this truck — no climbing in to scan each item.",
 "qr.itemByItem": "Load item-by-item (FILO)",
 "qr.manifestSub": "{day} · {driver} · route {route}",
 "qr.manifestTitle": "{truck} · today's manifest",
 "qr.mileage": "Est. mileage",
 "qr.mpgUnit": "mpg",
 "qr.noCamera": "Camera unavailable — tap Simulate scan",
 "qr.noTruck": "No truck assigned to this driver",
 "qr.products": "PRODUCTS",
 "qr.simulate": "Simulate scan",
 "qr.title": "Scan truck QR",
 "qr.truckVerified": "{truck} verified · {day} manifest",
 "qr.verifiedAll": {
  "one": "Truck QR scanned — {n} item load-verified in one scan · loader accountable",
  "other": "Truck QR scanned — {n} items load-verified in one scan · loader accountable"
 },
 "qr.verifyAll": "Load-verify all — count &amp; confirm",
 "receipt.needsOffice": "Emailing the invoice needs the office connection and a real stop.",
 "receipt.sending": "Sending the invoice…",
 "receipt.sent": "Invoice {number} emailed to {to}",
 "receipt.why.failed": "Not emailed — the email did not go. Print the receipt, or the office can resend it.",
 "receipt.why.noEmail": "Not emailed — no email on file for this customer. Print the receipt instead.",
 "receipt.why.notInvoiced": "Not emailed — the office has no invoice for this stop yet. Email it from the completed stop once it has synced.",
 "receipt.why.notYours": "Not emailed — that stop is not on your route.",
 "receipt.why.offline": "Not emailed — no signal. Email it from the completed stop when you are back online.",
 "receipt.textAsk": "Ask the customer if a text is OK, then tap again",
 "receipt.textAskOffline": "No signal — ask the customer if a text is OK, then tap again; it goes when you are back online",
 "receipt.why.other": "Not emailed — {why}",
 "receipt.why.tooMany": "Not emailed — this invoice has already been emailed 3 times today. The office can resend it.",
 "receipt.why.tooManyFailures": "Not emailed — sending this invoice has failed too often today. Print the receipt; the office can resend it.",
 "receipt.why.unavailable": "Not emailed — emailing invoices is not available yet. Print the receipt instead.",
 "reopt.needsBackend": "Reoptimize needs the backend",
 "run.drivingNote": "Driving — controls minimized for safety. Open the full list when stopped.",
 "run.lastStop": "This is your last stop.",
 "run.nextStopOf": "NEXT STOP · {n} of {of}",
 "run.reasonReservice": "{reason} · tap to re-service",
 "run.rolledIn": "rolled in {time}",
 "run.skippedWord": "skipped",
 "run.started": {
  "one": "{truck} en route · {n} stop",
  "other": "{truck} en route · {n} stops"
 },
 "run.tapToView": "tap to view",
 "run.window": "Window",
 "sign.ask": "Ask them to sign in the box.",
 "sign.clear": "Clear",
 "sign.empty": "Nothing signed yet",
 "sign.notSaved": "Signature not saved — {why}",
 "sign.onPhone": "Signature taken — kept on this phone (demo, no office)",
 "sign.save": "Save signature",
 "sign.saved": "Signature saved",
 "sign.savedOffline": "Signature saved — will send when back online",
 "sign.title": "Customer signature",
 "skip.back": "{name} back on the route",
 "skip.done": "Skipped {name} · {reason}",
 "skip.officeDefined": "Skip reasons are defined by the office.",
 "skip.r.closed": "Customer closed",
 "skip.r.noAccess": "No access",
 "skip.r.refused": "Refused delivery",
 "srv.already_paid": "Already paid in full ({paid} collected).",
 "srv.amount_invalid": "Amounts are in cents — at most two decimals.",
 "srv.amount_required": "Enter the amount you took.",
 "srv.amount_say": "Say how much.",
 "srv.amount_say_or_invoices": "Say how much, or which invoices it is for.",
 "srv.amount_too_large_link": "That amount is too large for a pay link.",
 "srv.arrival_time_required": "The phone did not say when you arrived.",
 "srv.bad_email": "That is not an email address.",
 "srv.bad_phone": "That is not a phone number we can text.",
 "srv.card_expired": "That card has expired.",
 "srv.card_needs_link": "A card is taken through the payment link or QR code — never typed in.",
 "srv.card_not_on_file": "That card is not on file for this customer.",
 "srv.card_refused": "The card could not be charged.",
 "srv.cards_not_set_up": "Card payments are not set up for this company — call the office.",
 "srv.cash_tally_invalid": "The cash tally is not valid.",
 "srv.check_number_required": "Enter the check number.",
 "srv.client_id_required": "The phone did not send its request id — update the app and try again.",
 "srv.contact_refused": "The contact was not saved.",
 "srv.contact_required": "Enter a mobile number or an email address.",
 "srv.count_negative": "The count for '{product}' cannot be negative.",
 "srv.customer_gone": "Customer not found.",
 "srv.damage_reason_required": "Say why the {product} was damaged.",
 "srv.day_closed": "This day is closed (Done) — its count can no longer change.",
 "srv.device_id_invalid": "This phone's id is missing or not valid.",
 "srv.device_register_failed": "Could not register this phone.",
 "srv.display_invalid": "That layout or theme is not available.",
 "srv.door_items_off": "Your company's security settings don't allow adding items at the door — call dispatch to change this order.",
 "srv.driver_gone": "Your driver record was not found — call the office.",
 "srv.email_not_set_up": "Email isn't set up on this server.",
 "srv.generic": "The server did not accept this.",
 "srv.image_too_large": "That image is too large — it should be resized on the device before upload.",
 "srv.invoice_choose": "Say which invoice to pay.",
 "srv.invoice_no_payment": "That invoice cannot take a payment.",
 "srv.invoice_not_customers": "That invoice is not this customer's.",
 "srv.invoice_not_raised": "The invoice has not been made yet.",
 "srv.invoice_unavailable": "The invoice is not available.",
 "srv.invoice_needs_price": "This invoice is waiting for the office to price it — it can be texted once it has a price.",
 "srv.load_ticks_invalid": "The load list could not be read.",
 "srv.no_phone": "No phone number on file for this customer — email or print the receipt.",
 "srv.order_locked": "Your company sets the stop order — reordering is off.",
 "srv.order_invalid": "That order does not match your stops — refresh your route and try again.",
 "srv.order_outdated": "A newer order was sent — your phone is showing it now.",
 "srv.overpay_invalid": "Say whether the extra was given back as change or kept as credit.",
 "srv.version_gone": "That order is not for your route today.",
 "srv.decision_invalid": "Choose use or keep.",
 "srv.no_route": "You have no route today.",
 "srv.nexus_off": "Nexus is not part of this company's plan.",
 "srv.not_invoiced": "The office has no invoice for this stop yet — it is raised when the delivery reaches the office.",
 "srv.text_send_failed": "The text did not go — email or print the receipt.",
 "srv.language_not_offered": "Your company does not offer that language.",
 "srv.language_required": "Choose a language.",
 "srv.link_send_failed": "The link was not sent.",
 "srv.load_count_invalid": "The load count is not valid.",
 "srv.load_counted_twice": "'{product}' is counted twice.",
 "srv.load_data_invalid": "The load count could not be read.",
 "srv.load_field_too_big": "The count for '{product}' is too large for a truck.",
 "srv.load_field_whole": "The count for '{product}' must be a whole number.",
 "srv.load_from_no_lines": "Your load has no counted lines to move from.",
 "srv.load_line_no_product": "A counted line has no product.",
 "srv.load_no_count": "'{product}' has no count.",
 "srv.load_not_counted": "Your load was not counted today, so there is nothing recorded to move.",
 "srv.load_phase_invalid": "It must be a load or an unload.",
 "srv.load_short": "You only have {have} {product} aboard.",
 "srv.load_to_no_lines": "The receiving truck's load has no counted lines.",
 "srv.method_invalid": "Method must be Cash, Check or Money Order.",
 "srv.mo_number_required": "Enter the money order number.",
 "srv.no_contact": "No contact on file — show the QR code.",
 "srv.no_invoice": "This stop has no invoice.",
 "srv.no_order_add": "This stop has no order to add to.",
 "srv.fill_lines_invalid": "A delivered line is not valid — check the quantities.",
 "srv.no_order_choose_invoice": "This stop has no order — choose the invoice to pay.",
 "srv.no_order_payment": "This stop has no order to take payment for.",
 "srv.no_truck": "No truck #{truck}.",
 "srv.not_available": "Not available.",
 "srv.not_on_route": "That stop is not on your route.",
 "srv.not_pending": "Only a stop still to do can be moved up.",
 "srv.nothing_owed": "Nothing is owed on that.",
 "srv.offroute_event_invalid": "Off route needs a start, a note or an end.",
 "srv.offroute_reason_required": "A reason is required to go off route.",
 "srv.oldest_first_rule": "Payments here go to the oldest open invoice first. Paying a specific invoice needs the office's permission.",
 "srv.order_closed": "This order is closed — nothing more can be added to it.",
 "srv.order_gone": "The order behind that stop is gone.",
 "srv.over_balance": "The amount is more than the balance of {balance}.",
 "srv.own_truck": "That is your own truck.",
 "srv.passkey_not_set_up": "Face ID or fingerprint sign-in is not set up.",
 "srv.password_change_required": "Choose a new password before you continue.",
 "srv.password_change_unavailable": "Ask your office to reset your password.",
 "srv.password_changed_sign_in": "Password changed — sign in again with it.",
 "srv.password_current_wrong": "Your current password is not right.",
 "srv.password_spaces": "A password cannot start or end with a space.",
 "srv.password_too_short": "Use at least {min} characters.",
 "srv.password_unchanged": "Choose a password different from the temporary one.",
 "srv.pay_link_refused": "The payment link could not be made.",
 "srv.pay_request_closed": "This payment request is no longer open.",
 "srv.pay_request_not_found": "That payment request was not found.",
 "srv.payment_refused": "The payment was not accepted.",
 "srv.period_closed": "That month is closed in accounting — the office has to sort it out.",
 "srv.print_format_invalid": "That print format is not available.",
 "srv.product_unknown_named": "'{product}' is not a product this company sells.",
 "srv.proof_kind_invalid": "The proof must be a photo or a signature.",
 "srv.proof_not_image": "The proof must be an image.",
 "srv.qty_invalid": "Quantity must be a whole number above zero.",
 "srv.reference_too_long": "That reference is too long.",
 "srv.route_code_required": "The route code is missing.",
 "srv.route_not_yours": "That route is not yours.",
 "srv.pretrip_required": "Submit the pre-trip inspection before you start the route.",
 "srv.posttrip_required": "Submit the post-trip inspection before you end the day.",
 "srv.inspection_day_required": "Open your route for today, then fill in the inspection.",
 "srv.inspection_type_invalid": "Choose pre-trip or post-trip.",
 "srv.odometer_required": "Enter the odometer reading.",
 "srv.odometer_invalid": "That odometer reading does not look right — check it.",
 "srv.odometer_below_pre": "The post-trip odometer cannot be lower than the pre-trip one ({pre} {unit}).",
 "srv.inspection_not_found": "That inspection report was not found.",
 "srv.odometer_unit_invalid": "Choose miles or kilometres for the odometer.",
 "srv.inspection_answer_required": "Choose “No defects” or list the defects you found.",
 "srv.inspection_defects_conflict": "A report with no defects cannot list defects.",
 "srv.inspection_defects_required": "List the defects you found, or choose “No defects”.",
 "srv.inspection_defects_too_many": "Too many defects on one report.",
 "srv.inspection_section_invalid": "A defect names an unknown part of the vehicle.",
 "srv.inspection_item_invalid": "A defect is not on the inspection form. Update the app.",
 "srv.inspection_item_twice": "The same item is listed twice.",
 "srv.inspection_trailer_required": "Enter the trailer number for a trailer defect.",
 "srv.inspection_other_note_required": "Describe the defect you marked as Other.",
 "srv.inspection_signature_required": "Sign the report.",
 "srv.inspection_signed_off": "The office has signed this report off — it can no longer be changed.",
 "srv.inspection_locked": "This report is locked now — tell the office about anything new.",
 "srv.truck_label_required": "Enter the truck number.",
 "srv.inspection_conflict": "Another report for this day was saved at the same moment — try again.",
 "srv.posttrip_before_start": "Start the route before you file the post-trip inspection.",
 "srv.pretrip_after_start": "The route has already started — a pre-trip inspection cannot be filed now. Tell the office.",
 "srv.inspection_day_closed": "The day is done — no new inspection report can be filed for it.",
 "insp.t.air_compressor": "Air Compressor",
 "insp.t.air_lines": "Air Lines",
 "insp.t.axles": "Axles",
 "insp.t.batteries": "Battery(s)",
 "insp.t.belts_hoses": "Belts/Hoses",
 "insp.t.body_frame": "Body/Frame",
 "insp.t.brakes_adjustment": "Brakes/Adjustment",
 "insp.t.brakes_service": "Brakes - Service System",
 "insp.t.brakes_parking": "Brakes - Parking System",
 "insp.t.charging_system": "Charging System",
 "insp.t.clutch": "Clutch",
 "insp.t.cooling_system": "Cooling System",
 "insp.t.coupling_devices": "Coupling Devices",
 "insp.t.documents": "Documents (insurance, permits, etc.)",
 "insp.t.doors_compartments": "Doors/Compartments",
 "insp.t.drive_lines": "Drive Lines",
 "insp.t.emergency_equipment": "Emergency Equipment",
 "insp.t.emergency_exits": "Emergency Windows/Exits",
 "insp.t.engine": "Engine",
 "insp.t.exhaust_system": "Exhaust System",
 "insp.t.fire_extinguishers": "Fire Extinguishers",
 "insp.t.first_aid_kit": "First Aid Kit",
 "insp.t.fluid_leaks": "Fluid Leaks",
 "insp.t.frame": "Frame",
 "insp.t.fuel_system": "Fuel System",
 "insp.t.heaters_defrosters": "Heaters/Defrosters",
 "insp.t.horns": "Horns",
 "insp.t.inspection_decal_plates": "Inspection Decal/Licence Plates",
 "insp.t.interior_lights": "Interior Lights",
 "insp.t.lights_reflectors": "Lights/Reflectors",
 "insp.t.load_security_devices": "Load Security Devices",
 "insp.t.lubrication_systems": "Lubrication System(s)",
 "insp.t.mirrors": "Mirrors",
 "insp.t.mud_flaps": "Mud Flaps",
 "insp.t.oil_pressure": "Oil Pressure",
 "insp.t.rear_end": "Rear End",
 "insp.t.recording_devices": "Recording Device(s)",
 "insp.t.seats": "Seats",
 "insp.t.suspension": "Suspension",
 "insp.t.steering_mechanism": "Steering Mechanism",
 "insp.t.transmissions": "Transmission(s)",
 "insp.t.wheels_tires_studs": "Wheels/Tires/Studs",
 "insp.t.windows_visibility": "Windows/Visibility",
 "insp.t.wipers_washers": "Wipers/Washers",
 "insp.t.other": "Other",
 "insp.tr.air_lines_glad_hands": "Air Lines/Glad Hands",
 "insp.tr.axles": "Axles",
 "insp.tr.body_frame": "Body/Frame",
 "insp.tr.brakes_adjustment": "Brakes/Adjustment",
 "insp.tr.coupling_devices": "Coupling Devices",
 "insp.tr.coupling_kingpin": "Coupling - Kingpin",
 "insp.tr.doors_compartments": "Doors/Compartments",
 "insp.tr.inspection_decal_plates": "Inspection Decal/Plates",
 "insp.tr.landing_gear": "Landing Gear",
 "insp.tr.lights_reflectors": "Lights/Reflectors",
 "insp.tr.load_security_dunnage": "Load Security/Dunnage",
 "insp.tr.mud_flaps": "Mud Flaps",
 "insp.tr.suspension": "Suspension",
 "insp.tr.wheels_tires_studs": "Wheels/Tires/Studs",
 "insp.tr.other": "Other",
 "insp.g.brakes_air": "Brakes & air",
 "insp.g.engine": "Engine & fluids",
 "insp.g.drivetrain": "Drivetrain",
 "insp.g.electrical": "Electrical & lights",
 "insp.g.chassis": "Chassis, wheels & steering",
 "insp.g.cab": "Cab & body",
 "insp.g.safety": "Safety & documents",
 "insp.g.other": "Other",
 "insp.g.trailer1": "Trailer #1",
 "insp.g.trailer2": "Trailer #2",
 "insp.title.pre": "Pre-trip inspection",
 "insp.title.post": "Post-trip inspection",
 "insp.required": "Required by your company",
 "insp.optional": "Optional",
 "insp.close": "Close",
 "insp.truck": "Truck #",
 "insp.truckPh": "Truck number",
 "insp.odo": "Odometer",
 "insp.odoPh": "Reading",
 "insp.mi": "Miles",
 "insp.km": "Km",
 "insp.q": "What did you find?",
 "insp.none": "No defects",
 "insp.noneSub": "I detected no defect or deficiency",
 "insp.found": "Found defects",
 "insp.foundSub": "I found defects — choose them below",
 "insp.search": "Search items",
 "insp.searchNone": "No item matches “{q}”",
 "insp.addTrailer": "Add trailer",
 "insp.trailerPh": "Trailer number",
 "insp.picked": "Defects: {n}",
 "insp.note": "What is wrong?",
 "insp.photo": "Photo",
 "insp.photoRetake": "Retake",
 "insp.remove": "Remove",
 "insp.remarks": "Remarks",
 "insp.remarksPh": "Anything else the office should know (optional)",
 "insp.sign": "Sign here",
 "insp.signClear": "Clear",
 "insp.signedBy": "{name} · {date} · {time}",
 "insp.submit": "Submit inspection",
 "insp.sending": "Sending…",
 "insp.need.truck": "Enter the truck number.",
 "insp.need.odo": "Enter the odometer reading.",
 "insp.need.answer": "Tap No defects, or choose the defects you found.",
 "insp.need.defect": "Choose at least one defect.",
 "insp.need.other": "Describe the defect marked Other.",
 "insp.need.trailer": "Enter the trailer number.",
 "insp.need.sign": "Sign the report.",
 "insp.sent": "Inspection sent to the office.",
 "insp.queued": "Saved on this phone — it will be sent when you have signal.",
 "insp.notSent": "Inspection not sent: {why}",
 "insp.storeFailed": "Could not keep the inspection on this phone — free some space and try again.",
 "insp.noRoute": "Open today's route first.",
 "insp.status.none": "Not done",
 "insp.status.pending": "Waiting to send",
 "insp.status.sent": "Submitted {time}",
 "insp.status.clean": "No defects",
 "insp.status.defects": "Defects reported: {n}",
 "insp.status.signedOff": "Signed off by the office",
 "insp.do": "Fill in",
 "insp.redo": "Correct it",
 "insp.sendNow": "Send now",
 "insp.gate.pre": "Submit the pre-trip inspection to start the route.",
 "insp.gate.post": "Submit the post-trip inspection to end the day.",
 "insp.offerPost": "Do the post-trip inspection before you finish.",
 "insp.skip": "Skip for now",
 "srv.send_channel": "Send by email or text.",
 "srv.send_provider_failed": "The provider did not accept it.",
 "srv.send_rate_day": "Already sent {n} times today.",
 "srv.send_rate_hour": "Already sent {n} times in the last hour — wait before sending again.",
 "srv.signin_failed": "Sign-in failed.",
 "srv.skip_reason_required": "A skipped stop needs a reason.",
 "srv.sms_consent": "Ask the customer first: texting needs their OK to this number.",
 "srv.sms_not_set_up": "Texting isn't set up for this company — send by email.",
 "srv.sms_opted_out": "That number asked not to get texts — send by email instead.",
 "srv.stop_already_delivered": "This stop is already delivered — nothing more can be added to it.",
 "srv.stop_not_found": "That stop does not exist.",
 "srv.stop_status_invalid": "A stop must be done, skipped or pending.",
 "srv.tender_amount": "Enter the amount.",
 "srv.tender_cents": "Amounts are in cents — at most two decimals.",
 "srv.tender_dup_id": "Two payments carry the same id.",
 "srv.tender_none": "Enter at least one payment.",
 "srv.tender_too_many": "That is more payments than one collection can take.",
 "srv.transfer_lines_required": "Say what moved: a product and a quantity above zero.",
 "srv.transfer_refused": "The transfer was not accepted.",
 "srv.truck_load_not_counted": "Truck #{truck}'s load was not counted today — confirm it first.",
 "srv.truck_not_out": "Truck #{truck} is not out on a route today.",
 "srv.unknown_product": "That is not a product this company sells.",
 "srv.unload_none": "Count at least one product.",
 "srv.unload_refused": "The unload count was not accepted.",
 "srv.unpriced_cap": "This order has no prices, so no more than {cap} can be taken here — call the office.",
 "srv.unpriced_cap_held": "This order has no price and {held} is already held for it — no more than {cap} in all can be taken before it is priced. Call the office.",
 "step.load": "Load",
 "stop.immovableDone": "{name} has already been delivered",
 "stop.immovableSkipped": "{name} was skipped — it is off this run",
 "stop.pinned": "That stop is pinned — unlock it first",
 "stop.positionDelivered": "That position is already delivered — drop it after the delivered stops",
 "stop.resequenced": "Re-sequenced — this stop is now next",
 "stop.routeResequenced": "Route {route} re-sequenced",
 "stop.title": "Stop {n}",
 "sync.b.deliveries": "Deliveries",
 "sync.b.loads": "Load counts",
 "sync.b.other": "Other",
 "sync.b.storage": "Phone storage",
 "sync.heldOne": "Not saved yet — keep the app open; it is saved when there is space or signal",
 "sync.heldBanner": {
  "one": "{n} change not saved yet — keep the app open; free space or get signal",
  "other": "{n} changes not saved yet — keep the app open; free space or get signal"
 },
 "dh.stop.notSaved": "Not saved yet",
 "sync.b.payments": "Payments",
 "sync.b.photos": "Photos and signatures",
 "sync.b.skips": "Skips",
 "sync.couldntSendKept": {
  "one": "{n} delivery couldn’t be sent yet — kept on this phone and will be sent again",
  "other": "{n} deliveries couldn’t be sent yet — kept on this phone and will be sent again"
 },
 "sync.couldntSendTold": {
  "one": "{n} delivery couldn’t be sent — the office has been told",
  "other": "{n} deliveries couldn’t be sent — the office has been told"
 },
 "sync.d.lastOk": "Last confirmed by the office",
 "sync.d.lastRoute": "Route last refreshed",
 "sync.d.nothingWaiting": "Nothing waiting on this phone.",
 "sync.d.officeTold": "office told",
 "sync.d.realtime": "Live connection",
 "sync.d.result": "Sync now at {time}: {sent} sent, {left} still waiting",
 "sync.d.retryAt": "retry {time}",
 "sync.d.waitingHd": "Waiting to send",
 "sync.deliveryNotRecorded": "Delivery not recorded — {why}",
 "sync.keptHere": "kept on this phone, it will be sent again",
 "sync.loadNotRecorded": "Load not recorded with the office — {status}",
 "sync.loadSavedHere": "Load saved on this phone — the office will see it as soon as it can",
 "sync.never": "never",
 "sync.noOwner": "Not saved — this phone cannot tell who is signed in. Sign out and back in, then do that again.",
 "sync.noServer": "This build has no office connection to sync with.",
 "sync.storageFull": "This phone is out of storage — new work cannot be saved offline. Free up space, then call the office.",
 "sync.notSaved": "Not saved — {why}",
 "sync.now": "Sync now",
 "sync.officeTold": "the office has been told",
 "sync.offlineWord": "offline",
 "sync.proofFailed": "Could not save the proof ({status})",
 "sync.rt.connected": "Connected",
 "sync.rt.off": "Off",
 "sync.rt.polling": "Checking every 12 seconds (no live connection)",
 "sync.rt.reconnecting": "Reconnecting",
 "sync.serverError": "server error",
 "sync.synced": {
  "one": "Synced {n} saved action with the office",
  "other": "Synced {n} saved actions with the office"
 },
 "sync.syncing": "⟳ Syncing…",
 "talk.chip.delivered": "Mark delivered",
 "talk.chip.directions": "Directions",
 "talk.chip.next": "Next stop",
 "talk.chip.skip": "Skip",
 "talk.close": "Close (Esc)",
 "talk.fabTitle": "Hands-free — “next stop”, “directions”, “mark delivered”, “skip”",
 "talk.drv.next": "Your next stop is {name}{extra}.",
 "talk.drv.allDone": "You're all done — no stops left on this route.",
 "talk.drv.progress": "{done} of {total} stops done, {left} left, {money} collected on {route}.",
 "talk.drv.collected": "You have collected {money} so far today on {route}.",
 "talk.drv.noRoute": "No active route yet.",
 "talk.drv.limit": "You've reached today's Nexus limit — the phone answers by itself until tomorrow.",
 "talk.handsFree": "Hands-free",
 "talk.send": "Send",
 "talk.stop": "Stop",
 "talk.stopTitle": "Stop speaking (Esc)",
 "talk.sub": "Say what you need — I check with you before I change anything.",
 "talk.talk": "Talk",
 "talk.title": "Hands-free",
 "ticker.checked": "checked {time}",
 "ticker.watching": "Watching for changes to your route",
 "unload.checkAll": "Check all returns",
 "unload.ended": "{truck} shift complete · returns in",
 "unload.newDay": "New day starts {time} · new week Sunday {time}.",
 "unload.shiftDone": "Shift complete · {name}",
 "vocab.bags": "bags",
 "vocab.bottles": "bottles",
 "waive.explain": "This is recorded against the stop, so the office can see it was closed without one.",
 "waive.r.declined": "Customer declined to sign",
 "waive.r.door": "Left at door",
 "waive.r.nobody": "Nobody available to sign",
 "waive.r.pad": "Signature pad not working",
 "waive.recorded": "Recorded · {why}",
 "waive.title": "No signature — why?",
 "xfer.done": "Transferred {qty}× {item} — {truck}",
 "xfer.enterBoth": "Enter the truck number and a quantity",
 "xfer.explainDemo": "Meet another truck (per Dispatch) and move product between trucks — scanned out of yours, into theirs, and synced to Dispatch.",
 "xfer.explainLive": "Product moves off your truck and onto theirs. Dispatch sees it once it is recorded.",
 "xfer.product": "Product",
 "xfer.qty": "Quantity",
 "xfer.recorded": "{qty}× {item} moved to #{truck} ({to}) — recorded",
 "xfer.savedHere": "Transfer saved on this phone — it is sent when there is signal",
 "xfer.sending": "Sending {qty}× {item} — #{truck}…",
 "xfer.toTruck": "To truck",
 "xfer.toTruckNo": "To truck #",
 "xfer.truckPh": "e.g. 142",
 "dh.done.invoice": "Invoice {n}",
 "dh.noroute.tools": "While you wait",
 "dh.off.local": "kept on this phone (demo — no office)",
 "dh.off.notSaved": "This phone could not save the off-route session — free some space on the phone.",
 "dh.off.note": "Note",
 "dh.off.pick": "Pick what you are doing first.",
 "dh.recap.sub": "Read-only",
 "dh.recap.prev": "Previous day",
 "dh.recap.next": "Next day",
 "dh.recap.noFuture": "A day that has not happened has no recap.",
 "dh.recap.today": "Today · {date}",
 "dh.recap.yesterday": "Yesterday · {date}",
 "dh.recap.loading": "Loading…",
 "dh.recap.failed": "Could not load that day. It will load when you are back online.",
 "dh.recap.none": "No route ran for you on this day.",
 "dh.recap.noneWhy": "A day shows up here once a route has been run and closed out under this login. Use the arrows to look at earlier days.",
 "dh.recap.route": "Route",
 "dh.recap.truck": "Truck",
 "dh.recap.clock": "On the clock",
 "dh.recap.done": "stops done",
 "dh.recap.skipped": "skipped",
 "dh.recap.units": "delivered",
 "dh.recap.collected": "collected",
 "dh.recap.stops": "Stops",
 "dh.recap.only": "{what} only",
 "dh.recap.delivered": "{n} delivered",
 "dh.recap.picked": "{n} picked up",
 "dh.recap.planned": "planned {n}",
 "dh.recap.noStops": "No stops on this route.",
 "dh.recap.noneOf": "None on this day.",
 "dh.recap.flags": "To explain at check-in",
 "dh.recap.money": "Money taken",
 "dh.recap.noMoney": "No money collected on this day.",
 "dh.recap.equipment": "Equipment / service",
 "dh.recap.demo": "Sample day — this build has no live driver history, so the screen is shown over demo data.",
 "dh.recap.readOnly": "Read-only — a past day cannot be changed from the truck. Distance is not shown because no odometer or GPS roll-up is recorded for a completed day.",
 "block.holdPayFull": "On HOLD — deliver only when paid in full",
 "dh.stop.holdCod": "The office put this customer on hold — deliver only if they pay in full now. Call your route manager with questions",
 "dh.stop.holdWarn": "The office put this customer on hold — check with your route manager before delivering",
 "dh.hold.callWho": "Route manager: {name} {phone}",
 "dh.hold.noManager": "Your company has not named a route manager — call the office",
 "dh.hold.manager": "route manager",
 "dh.hold.call": "Call {name}",
 "dh.hold.nowHeld": "{name} was just put on hold by the office",
 "dh.start.title": "Start your day first",
 "dh.start.ready": "The truck check and the load are done.",
 "dh.start.notReady": "The truck check or the load is not done. You can start without them — say why; the office sees it.",
 "dh.start.why": "Why are you starting without the checks?",
 "dh.start.whyPh": "e.g. checklist tablet broken",
 "dh.start.whyNeeded": "Say why (at least 4 characters)",
 "dh.start.without": "Start without checks",
 "dh.start.bypassed": "Started without the checks — the office sees why",
 "dh.eod.closeFirst": {
  "one": "Close the open stop first",
  "other": "Close the {n} open stops first"
 },
 "dh.eod.closeRest": {
  "one": "Close the open stop",
  "other": "Close {n} open stops"
 },
 "dh.eod.closeTitle": {
  "one": "Close the open stop",
  "other": "Close {n} open stops"
 },
 "dh.eod.closeSub": "Each is skipped with this reason — the office sees it and the stop carries to the next day.",
 "dh.eod.closed": {
  "one": "{n} stop closed",
  "other": "{n} stops closed"
 },
 "dh.eod.doneRefused": "The office still shows open stops — refreshing your route",
 "contact.noEmail": "No email on file for {name}",
 "contact.emailing": "Email to {name} · {email}",
 "dh.stops.email": "Email",
 "dh.stops.search": "Search today’s stops",
 "dh.stops.searchPh": "Search today’s stops — name, address, order",
 "dh.stops.searchNone": "No stop on today’s route matches “{q}”",
 "dh.info.contact": "Contact",
 "dh.hist.average": {
  "one": "Average of the last delivery: {money}",
  "other": "Average of the last {n} deliveries: {money}"
 },
 "dh.more.invoices": "Today’s invoices",
 "dh.routing.changedBy": "{who} changed your stop order at {time} — next: {next}",
 "dh.stops.forNext": "Next stop · {name}",
 "dh.routing.who.monitor": "The Monitor agent",
 "dh.routing.who.nightly": "The nightly plan",
 "dh.routing.who.dispatcher": "The office",
 "dh.routing.who.route-optimizer": "The route optimizer",
 "dh.routing.who.plan": "The plan",
 "dh.routing.who.driver": "You",
 "dh.todayinv.title": "Today’s invoices",
 "dh.todayinv.sub": {
  "one": "{n} invoice · {money}",
  "other": "{n} invoices · {money}"
 },
 "dh.todayinv.none": "No invoices on today’s route yet",
 "dh.todayinv.paid": "Paid",
 "dh.todayinv.part": "{money} taken",
 "dh.todayinv.open": "Not paid",
 "dh.todayinv.needsPrice": "Waiting for a price",
 "dh.todayinv.noAmount": "No amount yet",
 "dh.todayinv.loadFailed": "Could not load today’s invoices — try again with signal",
 "dh.todayinv.docFailed": "Could not open that invoice — try again with signal",
 "dh.inv.title": "Truck inventory · {truck}",
 "dh.stock.title": "Staged truck load",
 "dh.stock.explain": "The warehouse staged this load. Accept it, or flag what you counted.",
 "dh.stock.line": "{n}× {product}",
 "dh.stock.accept": "Accept",
 "dh.stock.flag": "Flag discrepancy",
 "dh.stock.itemized": "Load item by item instead",
 "dh.stock.accepted": "Staged load accepted",
 "dh.stock.flagged": "Your count was sent to the office",
 "dh.stock.acceptedBanner": "You accepted the staged load",
 "dh.stock.flaggedBanner": "Your count is the load — the office was told",
 "dh.stock.flagTitle": "Flag discrepancy",
 "dh.stock.flagExplain": "Enter what is actually on the truck. The office sees each difference.",
 "dh.stock.staged": "Staged {n}",
 "dh.stock.note": "Note (optional)",
 "dh.stock.send": "Send count",
 "dh.inv.loading": "Loading the truck’s stock…",
 "dh.inv.unavailable": "The truck’s stock could not be loaded. Try again with signal.",
 "dh.inv.balance": "{n} on the truck",
 "dh.inv.sub": "Started {start} · sold {sold}",
 "dh.inv.negative": "Below zero: more was sold than was loaded. The office reconciles it at the dock.",
 "dh.inv.src.verified": "Starting stock: the load you checked.",
 "dh.inv.src.flagged": "Starting stock: your count.",
 "dh.inv.src.staged": "Starting stock: the warehouse’s staged load (not checked by you).",
 "dh.inv.src.auto_committed": "Starting stock: the staged load, committed when the truck left the yard unchecked.",
 "dh.inv.src.assumed": "Starting stock: assumed from the end-of-day count (not a count).",
 "dh.inv.src.zero": "Starting stock: zero.",
 "srv.load_check_required": "Your company requires the truck’s load to be checked before selling. Check the load first.",
 "srv.load_check_itemized": "Your company checks the load item by item — use Load.",
 "srv.nothing_staged": "Nothing has been staged for this truck yet.",
 "srv.stock_count_invalid": "Enter each count as a whole number, 0 or more.",
 "dh.inv.untiedRow": "Not tied to a product",
 "dh.inv.untiedSub": "{n} sale line(s) · {money}",
 "dh.inv.untiedWarn": "Some sales today are not tied to a product, so product balances may read high. The office reconciles it at the dock.",
 "srv.stop_already_recorded": "This stop was just recorded by another write from the phone. Check it before sending again.",
 "srv.stop_invoiced": "This stop is already delivered and invoiced — it can't be reopened from the phone. Call the office if it needs changing.",
 "srv.deposit_counts_invalid": "The container counts don't add up — check the empties out and back, then try again.",
 "dh.inv.balanceUnknown": "not known",
 "dh.inv.soldUnknown": "{n} sale line(s) today are not tied to a product, so what is left on the truck is not known. The office reconciles it at the dock.",
 "srv.stock_count_incomplete": "Count every product on the truck.",
 "dh.eod.countNote": "Count what came back on the truck, product by product, and what is damaged. Tick each product you counted.",
 "dh.eod.backCol": "Came back",
 "dh.eod.damagedCol": "Damaged",
 "dh.eod.returned": "{product} came back",
 "dh.eod.damaged": "{product} damaged",
 "dh.eod.whyLabel": "Why damaged (if any)",
 "dh.eod.whyDamaged": "Say why the damaged product is damaged before Done.",
 "dh.eod.countSent": "Count sent to the office",
 "dh.eod.countQueued": "Count saved on the phone — it is sent when you have signal",
 "dh.stock.strictBanner": "Check your load before selling",
 "dh.stock.strictSub": "Your company requires the truck’s load to be checked item by item first.",
 "dh.stock.strictGo": "Check the load",
 "srv.customer_on_hold": "The office put {name} on hold. Do not deliver — call your route manager for next steps. You can still take a payment.",
 "srv.hold_pay_in_full_named": "The office put {name} on hold: deliver only when paid in full. Call your route manager.",
 "srv.hold_pay_in_full": "This customer is on hold: deliver only when paid in full — {money} is still owed for this stop. Call your route manager.",
 "srv.stops_open": "{n} stop(s) still open. Deliver or skip them before Done.",
 "srv.start_required": "Start the day first (or start without the checks, with the reason).",
 "srv.start_reason_required": "Say why you are starting without the checks (4 to 240 characters).",
 "srv.close_stops_required": "Say which day and which stops to close.",
 "srv.not_assigned": "You have no route today.",
 "dh.eod.closeFailed": "Could not close the stops — nothing was changed. Try again with signal.",
 "dh.eod.officeOpen": {
  "one": "The office still has 1 stop open",
  "other": "The office still has {n} stops open"
 },
 "dh.eod.officeOpenSub": "Close them with a reason, or call the office if you delivered them.",
 "dh.routing.orderBy": "Stop order set by {who} · {time}",
 "talk.speedN": "Speed {n}×",
 "talk.speedTitle": "How fast Nexus speaks — tap to change",
 "talk.speedSample": "This is how fast I will speak.",
 "talk.engine.title": "Which voice spoke the last answer",
 "talk.engine.neural": "Natural voice",
 "talk.engine.device": "Device voice",
 "talk.engine.none": "Voice off",
 "dh.or.btn": "Off route",
 "dh.or.btnHint": "Find an account",
 "dh.or.btnLive": "You are off route since {time}",
 "dh.or.title": "Off route",
 "dh.or.scope.route": "Searching your assigned routes",
 "dh.or.scope.branch": "Searching your branch territory",
 "dh.or.scope.company": "Searching the whole company",
 "dh.or.scope.noHome": "Your company limits searches to your branch, but no home branch is set for you — only your own routes are searched. Ask the office to set it.",
 "dh.or.tabSearch": "Search",
 "dh.or.tabNear": "Near me",
 "dh.or.searchLabel": "Search accounts",
 "dh.or.searchPh": "Name, DBA, account # or street",
 "dh.or.typeMore": "Type at least 2 letters or numbers.",
 "dh.or.searching": "Searching…",
 "dh.or.none": "No account matches “{q}”.",
 "dh.or.capped": "Showing the first {n} — type more to narrow it down.",
 "dh.or.failed": "The search did not come back. Try again.",
 "dh.or.offline": "You are offline — finding an account needs a signal. Nothing is shown until the phone is back online.",
 "dh.or.demo": "Design build — sample accounts, not your company’s.",
 "dh.or.status.served": "Served today",
 "dh.or.status.scheduled": "Scheduled today",
 "dh.or.status.none": "Not on today’s work",
 "dh.or.onMine": "On your route",
 "dh.or.dba": "DBA {name}",
 "dh.or.acct": "Account #{n}",
 "dh.or.pastDue": "Past due {amount}",
 "dh.or.noPin": "Not on the map yet",
 "dh.or.near.locating": "Finding where you are…",
 "dh.or.near.noFix": "Can’t find where you are — turn on location for this app, or search by name instead.",
 "dh.or.near.within": "Within",
 "dh.or.near.radius": "{n} mi",
 "dh.or.near.count": {
  "one": "{n} account within {r}",
  "other": "{n} accounts within {r}"
 },
 "dh.or.near.none": "No accounts within {r} of you.",
 "dh.or.near.you": "You are here",
 "dh.or.near.map": "Map of accounts near you",
 "dh.or.near.legend": "Pin colours",
 "dh.or.card.loading": "Opening the account…",
 "dh.or.card.failed": "The account did not open. Try again.",
 "dh.or.card.gone": "That account is not one you can look up.",
 "dh.or.card.holdWhy": "On hold — {reason}. Call your route manager before serving.",
 "dh.or.card.hold": "On hold. Call your route manager before serving.",
 "dh.or.card.access": "Site access and gate codes",
 "dh.or.card.notes": "Office notes",
 "dh.or.card.visits": "Last visits",
 "dh.or.card.noVisits": "No recorded visits yet.",
 "dh.or.card.delivered": "Delivered {n}",
 "dh.or.card.call": "Call {phone}",
 "dh.or.card.start": "Start off-route stop",
 "dh.or.card.startSoon": "Arrives in the next update. For now, tell the office you are here and they will record the delivery.",
 "dh.or.card.here": "Tell the office I’m here",
 "dh.or.card.told": "The office has been told you are off route at {name}.",
 "dh.or.card.queued": "No signal — the office will be told when the phone is back online.",
 "dh.or.card.refused": "The office could not be told: {why}",
 "dh.or.card.local": "Design build — kept on this phone, not sent.",
 "dh.or.declare": "Tell the office what you are doing (reason and notes)",
 "dh.or.logRow": "Log what you did",
 "dh.or.endRow": "End off route",
 "dh.or.reasonStop": "Off-route stop",
 "dh.more.offroute": "Off route — find an account",
 "talk.drv.orFind": "Searching for <b>{q}</b> to go off route.",
 "talk.drv.orNear": "Opening the accounts near you.",
 "talk.chip.orNear": "Off route near me",
 "srv.not_in_scope": "That account is not one you can look up.",
 "srv.offroute_location_invalid": "That account is not recognised.",
 "srv.query_too_short": "Type at least 2 letters or numbers.",
 "srv.position_invalid": "Your position did not come through — try again when the phone has a GPS fix.",
 "dh.or.skipped": "Skipped today",
 "dh.or.badge": "OFF ROUTE",
 "dh.or.start.starting": "Starting the off-route stop…",
 "dh.or.start.offline": "You are offline — starting an off-route stop needs a signal. Nothing was sent.",
 "dh.or.start.failed": "The stop was not started: {why}",
 "dh.or.start.notYet": "Started — it will appear in your stops in a moment.",
 "dh.or.revisit.title": "Already served today",
 "dh.or.revisit.sub": "{name} was already served today. How should this visit be billed?",
 "dh.or.revisit.standalone": "New invoice",
 "dh.or.revisit.child": "Add to today’s invoice",
 "dh.or.far.title": "Not at the account?",
 "dh.or.far.sub": "You are {dist} from {name}. Start the off-route stop anyway?",
 "dh.or.far.anyway": "Start anyway",
 "dh.ci.chip": "Custom",
 "dh.ci.plainDigits": "Use plain digits 0–9 in the name.",
 "dh.ci.badChars": "A name cannot contain < or >.",
 "dh.ci.notInvoicedTitle": "Not invoiced",
 "dh.ci.notInvoiced": "Custom items are turned off — {items} was not invoiced.",
 "dh.ci.giveBack": "Give the customer {money} back.",
 "dh.ci.gaveBack": "I gave {money} back",
 "dh.ci.keepCredit": "Ask the office to add it as credit",
 "dh.ci.nothingTaken": "Nothing was collected for it.",
 "dh.ci.refundTold": "The office knows you gave {money} back",
 "dh.ci.creditTold": "The office knows to add it as credit",
 "dh.ci.open": "Custom product",
 "dh.ci.remove": "Remove",
 "dh.ci.title": "Custom product",
 "dh.ci.sub": "Something not in the catalogue — the office reviews it",
 "dh.ci.name": "Name",
 "dh.ci.namePh": "What is it?",
 "dh.ci.qty": "Quantity",
 "dh.ci.price": "Unit price",
 "dh.ci.lineTotal": "Line total",
 "dh.ci.add": "Add",
 "dh.ci.needName": "Give it a name.",
 "dh.ci.nameLong": "Keep the name to 80 characters.",
 "dh.ci.noCard": "That looks like a card number — never type card details here.",
 "dh.ci.badQty": "Quantity: a whole number from 1 to 999.",
 "dh.ci.needPrice": "Enter the unit price.",
 "dh.ci.badPrice": "Unit price: 0 to 10,000, in cents.",
 "dh.ci.added": "{item} added · {money}",
 "dh.ci.removed": "{item} removed",
 "dh.ci.alreadySent": "Already sent to the office — call the office to change it.",
 "dh.ap.open": "Add product",
 "dh.ap.title": "Add product",
 "dh.ap.sub": "Search the catalogue by name or SKU",
 "dh.ap.search": "Search",
 "dh.ap.searchPh": "Name or SKU",
 "dh.ap.none": "No product matches.",
 "dh.ap.done": "Done",
 "dh.ap.more": "Showing {n} of {of} — type to narrow",
 "sync.customRefused": "Not added: {item} — {why}. The office has been told.",
 "dh.ap.empty": "Nothing added yet — use Add product or Custom product.",
 "dh.ud.title": "Add these to {name}’s usual products?",
 "dh.ud.sub": "Tick what they should get next time. This delivery does not change.",
 "dh.ud.sold": "{n} sold today",
 "dh.ud.add": "Add selected",
 "dh.ud.skip": "Skip",
 "dh.ud.none": "Tick a product, or press Skip.",
 "dh.ud.done": "Usual products updated ({n})",
 "dh.ud.queued": "Saved on this phone — it will be sent",
 "srv.custom_items_off": "Your company does not allow custom items — choose a product from the truck or call the office.",
 "srv.custom_item_invalid": "That custom item is not valid — check the name, quantity and price.",
 "srv.add_defaults_off": "Your company does not let drivers change a customer’s usual products.",
 "srv.defaults_invalid": "Choose up to 50 products, each with a believable quantity.",
 "srv.defaults_order_stop": "This stop’s products come from its order — the office sets its usual products.",
 "dh.fill.tax": "Tax {rate}%",
 "dh.or.pay.photo": "Photo of the check",
 "dh.or.pay.photoDone": "Check photo saved",
 "dh.or.pay.photoQueued": "Check photo kept on the phone — it goes up when back online.",
 "dh.or.pay.photoSlow": "The office did not answer in time. The check photo is kept on the phone and sent on its own — tap Sync now to send it again.",
 "dh.or.pay.needPhoto": "Take a photo of the check first.",
 "dh.or.voiceStartAsk": "Start an off-route stop at <b>{name}</b>?",
 "dh.or.demoStart": "Design build — the stop is added to this phone’s sample route only.",
 "dh.or.cancel.btn": "Cancel stop",
 "dh.or.cancel.title": "Cancel this off-route stop?",
 "dh.or.cancel.sub": "Nothing was delivered at {name}. The stop leaves your day and is not moved to tomorrow. The office sees that you cancelled it.",
 "dh.or.cancel.yes": "Cancel the stop",
 "dh.or.cancel.keep": "Keep the stop",
 "dh.or.cancel.done": "Off-route stop at {name} cancelled",
 "dh.or.cancel.queued": "Off-route stop at {name} cancelled on this phone — it goes to the office when you have a signal",
 "dh.stock.countTitle": "Count your truck",
 "dh.stock.countSub": "Your company checks the load before anything is sold. Count what is on the truck now, item by item — enter 0 for anything you do not have.",
 "dh.stock.countSend": "Send the count",
 "dh.stock.countLater": "Later",
 "dh.stock.counted": "Load counted — you can sell now",
 "dh.or.truck.title": "Which truck are you in?",
 "dh.or.truck.sub": "You have no truck of your own on file. Choose the truck you are driving — today’s off-route sales come off its stock.",
 "dh.or.truck.pick": "Truck {number} · {type}",
 "srv.client_id_mismatch": "That start was already used for another account. Start the stop again.",
 "srv.truck_choice_required": "Choose the truck you are driving first.",
 "srv.offroute_stop_served": "This stop was served — it cannot be cancelled.",
 "srv.check_photo_required": "Take a photo of each check or money order first.",
 "srv.truck_invalid": "That truck is not one of your company’s trucks.",
 "srv.truck_in_use": "That truck is running another driver’s route today — choose another.",
 "srv.truck_mismatch": "Today’s off-route stops are already on another truck.",
 "srv.load_count_one_tap": "Your company accepts the staged load with one tap — use Accept or Flag discrepancy.",
 "dh.nudge.region": "Time-to-move reminders",
 "dh.nudge.linger.title": "Time to move",
 "dh.nudge.linger": "Time to head to {next} — ≈ {min} min drive, window closes {time}",
 "dh.nudge.lingerNoWin": "Time to head to {next} — ≈ {min} min drive",
 "dh.nudge.risk.title": "Window at risk",
 "dh.nudge.risk": "{next} — window closes {time}, ≈ {min} min drive. Leave now to make it.",
 "dh.nudge.long.title": "Long stop",
 "dh.nudge.long": "Still at {name} — finish the stop?",
 "dh.nudge.left.title": "Stop not finished",
 "dh.nudge.left": "You left {name} without finishing it",
 "dh.nudge.go": "Go",
 "dh.nudge.open": "Open",
 "dh.nudge.skip": "Skip",
 "dh.nudge.snooze": "Snooze {min} min",
 "dh.nudge.at": "{time}",
 "dh.nudge.at1": "{time}",
 "dh.nudge.more": "Show the whole message",
 "dh.nudge.dismiss": "Dismiss",
 "pw.confirm": "Confirm new password",
 "pw.done": "Password saved — you are signed in.",
 "pw.mismatch": "The two passwords do not match.",
 "pw.new": "New password",
 "pw.noReach": "Could not reach the office. Your password was not changed — try again.",
 "pw.save": "Save password",
 "pw.saving": "Saving…",
 "pw.spaces": "A password cannot start or end with a space.",
 "pw.title": "Set a new password",
 "pw.tooShort": "Use at least {min} characters.",
 "pw.why": "You signed in with a temporary password. Choose your own to continue — at least {min} characters.",
 "dh.nav.label": "Main",
 "dh.nav.today": "Today",
 "dh.nav.stops": "Stops",
 "dh.nav.map": "Map",
 "dh.nav.truck": "Truck",
 "dh.nav.more": "More",
 "dh.d.skippedAt": "Skipped {time}",
 "dh.d.aSkipped": "skipped",
 "dh.d.doneIn": "Delivered {time} · in window",
 "dh.d.doneLate": "Delivered {time} · after window",
 "dh.d.doneAt": "Delivered {time}",
 "dh.d.aDoneIn": "delivered in window",
 "dh.d.aDoneLate": "delivered after its window",
 "dh.d.aOpen": "no time window",
 "dh.d.missed": "Missed · closed {time}",
 "dh.d.aMissed": "window missed",
 "dh.d.atRisk": "At risk · by {time}",
 "dh.d.aRisk": "at risk",
 "dh.d.closes": "Closes {time}",
 "dh.d.aSoon": "window closes soon",
 "dh.d.aTimed": "timed window",
 "dh.d.order": "Order {n}",
 "dh.d.onHold": "On hold",
 "dh.d.openRecord": "{name} — see what was recorded",
 "dh.d.later": "LATER",
 "dh.d.nextAria": "Next stop",
 "dh.d.nextPill": "NEXT STOP",
 "dh.d.nextPillN": "NEXT STOP · {n} of {of}",
 "dh.d.openStop": "Open stop",
 "dh.d.arrive": "Arrive {time}",
 "dh.d.aStop": "Stop {n}, {state}",
 "dh.d.aOffDone": "Off-route stop, done",
 "dh.d.view": "View",
 "dh.d.offN": "+{n} off route",
 "dh.d.tools": "Stop list tools",
 "dh.d.search": "Search stops",
 "dh.d.filter": "Filter stops",
 "dh.d.leg.info": "{n} timed",
 "dh.d.leg.warn": "{n} tight",
 "dh.d.leg.bad": "{n} at risk",
 "dh.d.leg.ok": "{n} done",
 "dh.d.g.pre": "Pre-trip",
 "dh.d.g.load": "Load",
 "dh.d.g.route": "Route",
 "dh.d.g.now": "Now",
 "dh.d.g.onRoute": "On route",
 "dh.d.g.locked": "Locked",
 "dh.d.g.about": "~{time}",
 "dh.d.firstOpens": "First window opens",
 "dh.d.estFinish": "Est. finish",
 "dh.d.stopsToday": {
  "one": "stop today",
  "other": "stops today"
 },
 "dh.d.overview": "Day overview",
 "dh.d.preNote": "Your route unlocks after the pre-trip inspection — your company requires it every day.",
 "dh.d.toLoad": "To load · planned",
 "dh.d.greet.morning": "Morning, {name}",
 "dh.d.greet.afternoon": "Afternoon, {name}",
 "dh.d.greet.evening": "Evening, {name}",
 "dh.d.greetNone.morning": "Good morning",
 "dh.d.greetNone.afternoon": "Good afternoon",
 "dh.d.greetNone.evening": "Good evening",
 "dh.d.truckN": "Truck {n}",
 "dh.ps.remove": "Remove {name}",
 "dh.ps.short": "{n} of {of} — the rest goes back to the office",
 "dh.ps.less": "One less {name}",
 "dh.ps.more": "One more {name}",
 "dh.ps.fromTruck": "From truck",
 "dh.ps.custom": "Custom",
 "dh.ps.empty": "Nothing on this stop yet — add from the truck.",
 "dh.ps.removed": "{item} taken off this stop",
 "dh.ps.deliver": "Deliver",
 "dh.ps.meta": {
  "one": "{n} product · {items}",
  "other": "{n} products · {items}"
 },
 "dh.ps.totalDue": "Total due",
 "dh.ps.deliverCollect": "Deliver & collect",
 "dh.ps.takePhoto": "Take delivery photo",
 "dh.ft.title": "Add from truck",
 "dh.ft.countsNow": "counts are what's on board now",
 "dh.ft.countsUnknown": "truck counts not known yet",
 "dh.ft.onTruck": "{n} on truck",
 "dh.ft.left": "{n} left",
 "dh.ft.none": "None on truck",
 "dh.ft.tileAria": "{name}, {n} on this stop — tap to add one",
 "dh.ft.each": "{money} each",
 "dh.ft.done": "Done · {n} on Stop {seq} · {money}",
 "dh.ci.addTo": "Add to Stop {seq}",
 "dh.ci.addToMoney": "Add to Stop {seq} · {money}",
 "dh.cust.title": "Customer",
 "dh.ci.officeNote": "Office note on this order",
 "dh.ci.accountNotes": "Account notes",
 "dh.ci.termsChip": "Terms {terms}",
 "dh.ci.text": "Text",
 "dh.ci.balance": "Balance due",
 "dh.ci.pastDue": "{money} past due",
 "dh.ci.credit": "Credit on file",
 "dh.ci.asOf": "as of {time}",
 "dh.ci.emailQueued": "Saved on this phone — sent to the office for review when the signal is back",
 "dh.ci.emailLocal": "Saved on this phone (demo — no office here)",
 "dh.ci.emailSaved": "Saved — flagged for the office to confirm",
 "dh.ci.addEmailFor": "Add an email for {name}",
 "dh.ci.addEmailPh": "Add their email",
 "dh.ci.save": "Save",
 "dh.ci.account": "Account {n}",
 "dh.ci.loading": "Getting the account from the office…",
 "dh.ci.cardOffline": "The office can't be reached — showing what this phone has.",
 "dh.ci.acct": "Account",
 "dh.ci.holdWhy": "On hold:",
 "dh.ci.contacts": "Contacts",
 "dh.ci.delivery": "Delivery",
 "dh.ci.recent": "Recent deliveries",
 "dh.ci.allHistory": "See all history",
 "dh.ci.openNotes": {
  "one": "Open the note",
  "other": "Open {n} notes"
 },
 "dh.ci.emailBad": "That email does not look right — check it and save again.",
 "dh.pay.checkPhoto": "Check photo",
 "dh.pay.recordOnAcct": "Record {money} on account",
 "dh.pay.recordAmt": "Record {money} {method}",
 "dh.pay.recordTitle": "Record payment",
 "dh.pay.modeLabel": "Payment mode",
 "dh.pay.withDelivery": "With delivery",
 "dh.pay.payOnlyMode": "Payment only",
 "dh.pay.onAccount": "Taking payment on account · no delivery",
 "dh.pay.cardSafeT": "Processed by your payment provider",
 "dh.pay.cardSafe": "Card numbers are never stored on this phone or by us — the invoice keeps the last 4 only.",
 "dh.pay.charge": "Charge",
 "dh.pay.owed": "Owed",
 "dh.pay.amountDue": "Amount due",
 "dh.pay.cashReceived": "Cash received",
 "dh.pay.overTitle": "Overpaid {money} → customer credit",
 "dh.pay.overSub": "Customer credit becomes {money}",
 "dh.pay.nowPart": "{money} now",
 "dh.pay.staysPart": "{money} stays on account",
 "dh.pay.whyPartial": "Why partial?",
 "dh.pay.reason.short": "Short on cash",
 "dh.pay.reason.dispute": "Disputes amount",
 "dh.pay.reason.mail": "Will mail check",
 "dh.pay.reason.other": "Other",
 "dh.pay.shortNote": "{money} short — it stays on the account",
 "dh.pay.creditOnFile": "Credit on file {money}",
 "dh.pay.creditApplied": "{money} credit applied",
 "dh.pay.tender": "Tender",
 "dh.pay.keypad": "Keypad",
 "display.layout.deck": "Deck",
 "dh.look.hint.deck": "Default · new",
 "dh.d.collectedToday": "Collected today",
 "dh.stops.todo": "To do",
 "dh.stops.segAria": "Stops",
 "dh.d.skippedMark": "Skipped",
 "dh.nav.noRoute": "No route",
 "dh.nav.noRouteWhy": "No route today",
 "dh.truck.title": "Truck {n}",
 "dh.truck.yours": "Yours today",
 "dh.truck.onBoard": "On board now",
 "dh.truck.itemsLeft": "{n} left",
 "dh.truck.loaded": "Loaded",
 "dh.truck.sold": "Sold",
 "dh.truck.left": "Left",
 "dh.truck.noCounts": "Nothing is counted onto this truck yet.",
 "dh.truck.reports": "Truck inspections",
 "dh.truck.reportDone": "Completed {time}",
 "dh.truck.reportView": "View report",
 "dh.truck.reportNone": "Not done yet",
 "dh.truck.odo": "Odometer",
 "dh.truck.result": "Result",
 "dh.truck.signoff": "Office sign-off",
 "dh.truck.signed": "Signed off",
 "dh.truck.notSigned": "Not yet",
 "dh.truck.reportNote": "Read only. It was sent to the office when you finished it.",
 "dh.truck.moreInv": "Full truck inventory",
 "dh.alerts.title": "Alerts",
 "dh.alerts.bell": "Alerts",
 "dh.alerts.bellAria": "Alerts, {n} unread",
 "dh.alerts.new": "{n} new",
 "dh.alerts.markRead": "Mark all read",
 "dh.alerts.none": "No alerts. When the office changes your route, or something needs your attention, it shows here.",
 "dh.num.range": "Enter a number from {min} to {max}.",
 "srv.email_invalid": "That email does not look right.",
 "srv.email_exists": "This customer already has an email — the office changes it.",
 "srv.location_gone": "That stop’s location is gone.",
 "b2.insp.pre": "Pre-trip",
 "b2.insp.post": "Post-trip",
 "b2.insp.sub": "Trip Inspection Report · {date}",
 "b2.insp.required": "Required",
 "b2.insp.truckWord": "Truck",
 "b2.insp.unit": "Unit inspected",
 "b2.insp.tTruck": "Truck",
 "b2.insp.groups": "Parts of the truck",
 "b2.insp.all": "All {n}",
 "b2.insp.find": "Or find a defect · {n} items",
 "b2.insp.trailerNo": "{which} number",
 "b2.insp.addPhoto": "Add a photo of the defect",
 "b2.insp.noneBtn": "No defects · all good",
 "b2.insp.noneOn": "No defects · selected",
 "b2.insp.noneBlocked": "Remove the ticked defects to choose this",
 "b2.insp.remarksPh": "Remarks (optional)",
 "b2.insp.signed": "Signed · {name}",
 "b2.insp.odoLow": "Must be at least the pre-trip reading, {pre} {unit}",
 "b2.insp.preFlagged": "Pre-trip flagged {items} — still reported to the office.",
 "b2.insp.submitPre": "Submit pre-trip",
 "b2.insp.submitPost": "Submit post-trip",
 "b2.insp.nDefects": {"one": "{n} defect", "other": "{n} defects"},
 "b2.insp.gs.brakes_air": "Brakes",
 "b2.insp.gs.engine": "Engine",
 "b2.insp.gs.drivetrain": "Drivetrain",
 "b2.insp.gs.electrical": "Lights",
 "b2.insp.gs.chassis": "Wheels",
 "b2.insp.gs.cab": "Cab",
 "b2.insp.gs.safety": "Safety",
 "b2.insp.gs.other": "Other",
 "b2.truck.ticked": "Items reported",
 "b2.in.hero": "Ready to roll?",
 "b2.in.sub": "Sign in with the email or driver ID your office set up.",
 "b2.in.show": "Show password",
 "b2.in.hide": "Hide password",
 "b2.pw.hero": "Make it yours",
 "b2.pw.step": "Step 2 of 3",
 "b2.pw.weak": "Weak",
 "b2.pw.fair": "Fair",
 "b2.pw.good": "Good",
 "b2.pw.strong": "Strong",
 "b2.pw.strengthAria": "Strength: {word}",
 "b2.pw.ruleLen": "At least {min} characters",
 "b2.pw.ruleNum": "Includes a number",
 "b2.pw.ruleSame": "Both entries match",
 "b2.pw.save": "Save and continue",
 "b2.load.accepted": "Everything loaded as staged.",
 "b2.load.confirmed": "Load confirmed. Start the route from Today.",
 "b2.load.acceptAll": "Accept all as staged",
 "b2.load.itemByItem": "Load item by item instead",
 "b2.load.confirm": "Confirm load · {n} items",
 "b2.load.planned": "Planned {n}",
 "b2.load.notPlanned": "Not on the plan",
 "b2.load.short": "{n} short",
 "b2.load.extra": "{n} extra",
 "b2.load.ofLoaded": "/ {n} loaded",
 "b2.load.ofItems": "of {n} items loaded",
 "b2.load.st.loading": "Loading",
 "b2.load.st.loaded": "Loaded",
 "b2.load.st.locked": "Locked",
 "b2.load.hintOpen": "Accept all as staged, or set each product below.",
 "b2.load.match": "{a} of {b} products match the plan",
 "b2.load.toGo": "{n} to go",
 "b2.load.lockStarted": "Locked: the route started at {time}, so the load can no longer change.",
 "b2.load.lockNote": "Locks read-only when you start the route.",
 "b2.eod.sRoute": "Route",
 "b2.eod.sUnload": "Unload",
 "b2.eod.sPost": "Post-trip",
 "b2.eod.sDone": "Done",
 "b2.eod.productsLabel": "Products",
 "b2.eod.loadedCol": "Loaded",
 "b2.eod.damagedCol": "Damaged",
 "b2.eod.leftCol": "Left on truck",
 "b2.eod.formula": "Delivered + damaged + left on truck = loaded.",
 "b2.eod.loadedLine": "Loaded {n}",
 "b2.eod.expect": "{n} should be left",
 "b2.eod.tickRow": "{name}: left on truck is as expected",
 "b2.eod.unShort": "{n} unaccounted for",
 "b2.eod.unOver": "{n} more than loaded",
 "b2.eod.allExpected": "Everything as expected",
 "b2.eod.counted": "{a} of {b} counted",
 "b2.eod.countAll": "Count the products first: type each one, or tap its circle when it is as expected.",
 "b2.eod.nextPost": "Next: post-trip (required)",
 "b2.eod.tillLabel": "Cash and checks",
 "b2.eod.cashCounted": "Cash counted",
 "b2.eod.checksCounted": "Checks counted",
 "b2.eod.recorded": "Recorded {amount}",
 "b2.eod.recordedWait": "Recorded: loading",
 "b2.eod.recordedChecks": "Recorded {n} · {amount}",
 "b2.eod.matches": "Matches",
 "b2.eod.shortBy": "Short {amount}",
 "b2.eod.overBy": "Over {amount}",
 "b2.eod.checksMissing": {"one":"{n} check is not in hand. Find it:","other":"{n} checks are not in hand. Find them:"},
 "b2.eod.checksExtra": {"one":"{n} more check than recorded","other":"{n} more checks than recorded"},
 "b2.eod.unloadTitle": "Count the truck",
 "b2.map.onRoute": "On route",
 "b2.map.onSchedule": "On schedule",
 "b2.map.behind": "Behind schedule",
 "b2.map.allClosed": "All stops closed",
 "b2.map.finish": "finish about {time}",
 "b2.map.arrive": "arrive",
 "b2.map.distance": "from here",
 "b2.map.mi": "{n} mi",
 "b2.map.recenter": "Recenter the map",
 "b2.map.noNext": "No stop is next.",
 "b2.map.you": "This truck",
 "b2.skip.stop": "Stop {n}",
 "b2.skip.why": "Why are you skipping?",
 "b2.skip.sub": "Pick one, then confirm. The stop goes back to the office as skipped, and the office sees it right away.",
 "b2.skip.note": "Note (optional)",
 "b2.skip.photo": "Add a photo",
 "b2.skip.stay": "{n} items stay on the truck. You can still come back to Stop {stop} later today.",
 "b2.skip.pickFirst": "Pick a reason",
 "b2.skip.confirm": "Skip Stop {n} · {reason}",
 "b2.notes.title": "Notes",
 "b2.notes.sub": "Notes with the office · Stop {n}",
 "b2.notes.office": "Office",
 "b2.notes.you": "You",
 "b2.notes.q.onway": "On my way",
 "b2.notes.q.late": "10 min late",
 "b2.notes.q.thanks": "Thanks",
 "b2.notes.q.callme": "Call me",
 "b2.notes.ph": "Write a note to the office",
 "b2.notes.send": "Send note",
 "b2.notes.photo": "Attach a photo",
 "b2.notes.saved": "Sent",
 "b2.notes.pending": "Saved on this phone",
 "b2.notes.oneWay": "The office reads your note on this stop. Replies from the office are not in the app yet.",
 "b2.notes.sentToast": "Note sent to the office.",
 "b2.notes.phoneOnly": "Saved on this phone (not connected to the office).",
 "b2.inv.paid": "Delivered & paid",
 "b2.inv.delivered": "Delivered",
 "b2.inv.inWindow": "in window",
 "b2.inv.number": "Invoice {n}",
 "b2.inv.pending": "Invoice (number follows)",
 "b2.inv.paidVia": "Paid · {method}",
 "b2.inv.credit": "Overpaid → customer credit",
 "b2.inv.sendReceipt": "Send receipt",
 "b2.inv.noEmail": "No email yet — add one to send",
 "b2.inv.send": "Send",
 "b2.inv.alsoSaved": "Also saved to the account · the office will confirm it",
 "b2.inv.keptNoSend": "Email kept for the office. Print the receipt for now.",
 "b2.inv.keptWaiting": "Email kept. The receipt can go once the delivery reaches the office.",
 "b2.inv.afterWindow": "after window",
 "b2.inv.total": "Total",
 "b2.inv.invoice": "Invoice",
 "b2.off.acct": "Account {n}",
 "b2.off.count": {"one":"{n} account","other":"{n} accounts"},
 "b2.more.profile": "Profile",
 "b2.more.appearance": "Appearance",
 "b2.more.colour": "Color theme",
 "b2.more.help": "Help & contact the office",
 "b2.more.light": "Light",
 "b2.more.dark": "Dark",
 "b2.al.riskTitle": "Stop {n} at risk",
 "b2.al.t.all": "All",
 "b2.al.t.office": "Office",
 "b2.al.t.route": "Route",
 "b2.al.t.risk": "At risk",
 "b2.al.type": "Alert type",
 "b2.al.unread": "Unread",
 "b2.al.ok": "OK",
 "b2.al.review": "Review the new order",
 "b2.rv.title": "Day review",
 "b2.rv.sub": "Day review · {route} · Truck {truck}",
 "b2.rv.summary": "Day summary",
 "b2.rv.doneOf": "done of {n}",
 "b2.rv.offRoute": "off route",
 "b2.rv.collected": "Collected · cash + checks + cards",
 "b2.rv.skipped": "Skipped {time}",
 "b2.rv.after": "{n} min after window",
 "b2.rv.inWindow": "in window",
 "b2.rv.a.ok": "Stop {n}, delivered in window",
 "b2.rv.a.late": "Stop {n}, served after window",
 "b2.rv.a.skip": "Stop {n}, skipped",
 "b2.rv.a.none": "Stop {n}",
 "b2.rv.segAria": "Stops: {done} done, {skipped} skipped, {off} off route",
 "b2.skip.pickWhy": "Pick why you are skipping this stop.",
 "b2.eod.atLeast": "at least {n}",
 "b2.eod.loadedUnknown": "No measured load for this truck today (nothing was staged or counted), so what should be left cannot be worked out. Count what is on the truck.",
 "b2.off.since": "since {time}",
 "srv.password_no_digit": "Include at least one number in your password.",
 "insp.truckPick": "Choose a truck",
 "insp.truckFailed": "The company’s trucks could not be loaded.",
 "insp.truckLoading": "Loading the company’s trucks…",
 "insp.truckNone": "There are no trucks on file for this company. Ask the office to add yours.",
 "xfer.truckPick": "Choose a truck",
 "xfer.truckNone": "No other truck is out on a route today.",
 "xfer.trucksFailed": "The trucks out today could not be loaded. Try again with signal.",
 "dh.start.elsewhere": "This route was started on another device.",
 "srv.truck_unknown": "Truck {truck} is not one of the company’s trucks. Choose one from the list.",
 "srv.load_locked_started": "The route has started, so the load can no longer be changed.",
 "srv.truck_maintenance": "That truck is in maintenance — choose another.",
 "srv.truck_loading": "That truck is being loaded — choose another.",
 "dh.or.truck.filter": "Type a truck number",
 "srv.crew_not_found": "That driver or truck is not on file.",
 "insp.need.truckPick": "Choose the truck.",
 "dh.pay.creditAvail": "Credit available {money}",
 "dh.pay.creditApplyLabel": "Apply credit",
 "dh.pay.creditApplyHint": "Takes {money} off what is due",
 "dh.pay.creditStays": "Nothing is due, so the credit stays on the account",
 "dh.pay.creditAutoNote": "The company applies credit automatically",
 "dh.pay.creditUnknown": "Credit balance is not known offline — the office settles it",
 "dh.pay.overAdded": "Added to the customer's credit balance · new credit {money}",
 "dh.pay.overAddedNew": "Added to the customer's credit balance",
 "dh.done.creditNew": "Customer credit is now {money}",
 "dh.stop.creditAvail": "{money} credit on this account — apply it when you record the payment",
 "dh.pay.creditRulesUnknown": "The company's credit rule is not known yet — the office settles any credit when this syncs",
 "b2.notes.twoWay": "Your notes go to the office. Its replies appear here.",
 "dh.msg.sending": "Sending…",
 "dh.msg.seen": "Seen",
 "dh.msg.loading": "Reading the notes…",
 "dh.msg.offline": "No connection — showing the notes saved on this phone.",
 "dh.msg.unread": {"one":"{n} new from the office","other":"{n} new from the office"},
 "dh.msg.alert": {"one":"{name}: the office wrote back","other":"{name}: the office wrote {n} new notes"},
 "dh.msg.openNotes": "Open the notes",
 "alert.kind.msg": "Office note",
 "srv.message_empty": "Write a message first.",
 "srv.message_too_long": "That message is too long.",
 "p5.truck.returned": "Returned",
 "p5.truck.reload": "Reload truck",
 "p5.truck.pending": "{n} reload waiting to send.",
 "p5.truck.retNote": "Returned units stay on the truck; they are not counted as left to sell.",
 "p5.rl.title": "Reload truck",
 "p5.rl.sub": "Went back to the warehouse for more? Add what you loaded.",
 "p5.rl.sum": "{n} units to add",
 "p5.rl.none": "Add a quantity to at least one product",
 "p5.rl.send": "Confirm reload",
 "p5.rl.done": "Reload recorded",
 "p5.rl.queued": "Saved on this phone. It will be sent when you are online.",
 "p5.rl.empty": "There are no products to choose from.",
 "p5.rt.btn": "Customer return",
 "p5.rt.title": "Customer return · {name}",
 "p5.rt.sub": "Product the customer hands back. Good product goes back to sell; stale or damaged stays on the truck, not for sale.",
 "p5.rt.product": "Product",
 "p5.rt.qty": "Quantity",
 "p5.rt.why": "Why?",
 "p5.rt.why.good": "Good — sell again",
 "p5.rt.why.stale": "Stale",
 "p5.rt.why.damaged": "Damaged",
 "p5.rt.why.other": "Other",
 "p5.rt.send": "Record return",
 "p5.rt.needProduct": "Pick a product",
 "p5.rt.needQty": "Add a quantity",
 "p5.rt.needWhy": "Say why it came back",
 "p5.rt.done": "Return recorded",
 "p5.rt.queued": "Saved on this phone. It will be sent when you are online.",
 "p5.rt.list": "Returned by the customer",
 "p5.rt.row": "{n} · {why}",
 "p5.rt.pending": "waiting to send",
 "p5.eod.cust": "Customers returned {n}",
 "p5.inv.sub": "Loaded {loaded} · Delivered {sold} · Returned {ret}",
 "srv.reload_invalid": "Pick real products and whole quantities, 1 or more.",
 "srv.return_invalid": "Pick a product, a quantity of 1 or more, and why it came back.",
 "svc.badge": "SERVICE",
 "svc.title": "Service call",
 "svc.timeRecording": "Time is being recorded",
 "svc.timeRecorded": "Time recorded: {min} min",
 "svc.account": "Account",
 "svc.site": "Site",
 "svc.job": "The job",
 "svc.est": "about {min} min",
 "svc.equipment": "Equipment",
 "svc.expected": "On the ticket: {tag}",
 "svc.tagUnknown": "The equipment ID is not known — scan or type it.",
 "svc.tagPh": "Equipment ID",
 "svc.scan": "Scan tag",
 "svc.scanNone": "No tag was read in that photo — type the ID instead.",
 "svc.photos": "Photos",
 "svc.photoBefore": "Before photo",
 "svc.photoAfter": "After photo",
 "svc.parts": "Parts replaced",
 "svc.noParts": "No parts added.",
 "svc.addPart": "Add a part…",
 "svc.add": "Add",
 "svc.qty": "Quantity",
 "svc.remove": "Remove",
 "svc.noCatalogue": "The company has no parts list yet — write the parts in the notes.",
 "svc.notes": "Notes",
 "svc.speak": "Speak notes",
 "svc.listening": "Listening…",
 "svc.fixedInvoice": "Fixed — complete and charge the customer",
 "svc.fixedSummary": "Fixed — complete (invoice not charged)",
 "svc.cantFix": "Can't fix — complete and add an exchange",
 "svc.invoiceCompany": "Fixed — invoice the company",
 "svc.cantFixInvoice": "Can't fix — invoice the company and request an exchange",
 "svc.closedFixed": "Fixed — this service is closed.",
 "svc.closedCant": "Could not fix — this service is closed.",
 "svc.back": "Back to stops",
 "svc.billSent": "Your bill to the company: {amount}.",
 "svc.invoiced": "Invoice {number} created.",
 "svc.exchangeAdded": "An exchange order was added for the office.",
 "svc.queued": "Saved on this phone — it sends when there is signal.",
 "svc.invoicedNoCharge": "Invoice {number} created — not charged."
}
